module.exports = {
  message: {
    home: "首頁",
    ticket: "機票",
    contactUs: "聯繫我們",
    mySchedule: "我的行程",
    hotel: "酒店",
    login: "登錄",
    regist: "註冊",

    traditional: "繁體",
    chinese: "简体中文",
    english: "English",

    Enjoyatrip: "享受出行",
    Meetingtheworldandfeelingtheworld: "遇見世界 感受世界",

    Theaccountn: "使用此電郵地址並輸入密碼以建立賬戶。",
    createAccountForYou: "我們將幫您創建一個賬戶，以便接收關於行程的信息。",
    Relatedissues: "相關問題",
    fly: "約嗎，打著飛的看世界",
    ad: "搜索來自超過壹千家航空公司的最合適航班.",
    dot: "國內機票",
    int: "國際機票",
    Addinvoiceinformation: "添加發票信息",
    Invoiceinformation: "發票信息",
    Invoicetype: "發票類型",
    Sincereservicededicatedfeedback: "真誠服務 用心回饋",
    Alleffortsaretosatisfyyou: "一切努力 只為讓您更滿意",
    Invoicesareraised: "發票擡頭",
    Nostoppingflights: "不經過停航班",
    oneWay: "單程",
    Sendactivationcode: "發送激活碼",
    Select: "選择",
    twoWay: "往返",
    Aflighttothecity: "去的航班",
    Eliminate: "清除",
    Sendverificationcode: "發送驗證碼",
    Returnflight: "回的航班",
    Cityorairport: "城市或機場",
    Overtheageofage: "年齡（大於12）",
    accountmanagement: "賬號管理",
    manyWay: "多個目的地",
    fromCity: "出發城市",
    toCity: "到達城市",
    fromTime: "出發時間",
    toTime: "到達時間",
    returnTime: "返程時間",
    fromTimeAndReturn: "出發時間-返程時間",
    flightTo: "飛往",
    cabin: "客艙等級及旅客",
    search: "尋找航班",
    passenger: "旅客",
    traveler: "位旅客",
    advancedOptions: "高級選項",
    preferredAirline: "首選航空公司",
    preferred: "首選艙位",
    close: "關閉",
    addAnother: "添加另外一個航班",
    nonStop: "直飛",
    stop_1: "1 次經停",
    stop_2: "2 次經停",
    refundable: "可退款機票",
    adults: "成人",
    adultsNew: "成人（12+）",
    children: "兒童",
    infants: "嬰兒",
    adult: "成人",
    child: "兒童",
    childNew: "兒童（2-12）",
    infantsNew: "嬰兒（<2）",
    childrenAge: "年齡（2~12）",
    infantsAge: "2歲以內",
    showOptions: "顯示選項",
    hideOptions: "隱藏選項",
    seat: "座位等級",
    nonstopFlightsOnly: "直飛",
    refundableFlightsOnly: "僅限可退票航班",
    explain: "價格為單人往返票價，含所有稅費，但不含行李費。",
    sortBy: "分類",
    sortFilter: "分類和篩選",
    transit: "經停",
    startingPrice: "出發起價",
    city: "城市",
    airlinesIncluded: "包含的航空公司",
    morning: "上午",
    earlyMorning: "早晨",
    forenoon: "上午",
    afternoon: "下午",
    evening: "晚上",
    select: "選擇",
    freeCancellation24: "24小時內免費取消",
    booking_24: "預訂24小時以內可免費取消！",
    itineraryDetail: "航班詳情",
    hour: "小時",
    minute: "分鐘",
    baggageFee: "行李費",
    personalLuggage: "隨身行李",
    check_inLuggage: "托運行李",
    myOrder: "我的訂單",
    myTicket: "我的機票",
    invoice: "發票管理",
    paymentManagement: "支付管理",
    passwordManagement: "密碼管理",
    commonCard: "常用卡",
    passengerManagement: "旅客管理",
    postManagement: "郵寄管理",
    integralManagement: "積分管理",
    clientServiceCenter: "客服中心",
    preferentialCodeManagement: "優惠碼管理",
    recommendationsAndObservations: "建議與意見",
    accountBinding: "賬號綁定",
    deleteAnOrder: "刪除訂單",
    detailsQuery: "詳情查詢",
    fullOrder: "全部訂單",
    orderType: "訂單類型",
    firmOrder: "有效訂單",
    refundOrder: "退款訂單",
    orderTime: "訂單時間",
    LastMonth: "最近一個月",
    LastThreeMonth: "最近三個月",
    oneYear: "一年",
    from: "起",
    to: "到",
    refundSuccessful: "退款成功",
    ticketSuccessful: "出票成功",
    beingTickets: "正在出票",
    transactionClosure: "交易關閉",
    returnTicket: "退票",
    alterTickets: "改簽",
    totalOrders: "訂單總額",
    orderNumber: "訂單號",
    applyForSuccessful: "退票申請成功",
    refundTo: "出票方退款至我司",
    originalReturn: "退款按原路返還",
    bankActualTime: "（請以銀行實際時間為準）",
    refundPerson: "退票人",
    unbookedFlight: "退訂航班",
    cancellationCost: "C退訂費用",
    withdrawalTime: "退訂款項成功時間",
    Passenger: "乘機人",
    sex: "性別",
    birthday: "生日",
    nationality: "國籍",
    age: "年齡 ",
    passport: "護照",
    issueAt: "簽發地",
    periodOfValidity: "有效期",
    exchangeShop: "票號",
    toIssueTicket: "出票中...",
    outstandingTicket: "未出票",
    contacts: "聯繫人",
    phone: "電話",
    phoneExcample: "（例:+852-77776666,输入:77776666）",
    e_mail: "郵箱",
    logonMember: "登錄會員",
    LoginAccount: "登錄賬號",
    loginPassword: "登錄密碼",
    PleaseEnterPhone: "請輸入電話號碼/郵箱地址",
    PleaseEnterPassword: "請輸入登錄密碼",
    ForgetPassword: "忘記密碼?",
    Savestatus: "保存登錄狀態",
    Logimmediately: "立即登錄",
    LogonAs: "登錄為",
    Worldline: '"Trip"',
    AfterUser: "用戶後，您可以",
    TravelAgent: "暢遊與Trip合作的機票代理商網站，輕松管理訂單",
    Queryplan: "查詢、計劃、管理您的預定信息",
    //ExclusiveSpecial:"會員獨家優惠和特價促銷",
    thirdPartyLogon: "支持第三方登錄",
    register: "註冊新會員",
    switch: "切換",
    mailbox: "郵箱",
    PhoneNumber: "電話號碼",
    NationalArea: "國家/地區",
    china: "中國",
    Registeredmailbox: "註冊郵箱",
    PleaseEnterMailbox: "請輸入郵箱地址",
    VerificationCode: "驗證碼",
    PleaseEnterVerification: "請輸入驗證碼",
    ExclusiveSpecial: "暢遊與環球行合作的機票代理商網站，輕松管理訂單",
    ActivationCode: "激活碼",
    PleaseEnteractivationCode: "請輸入激活碼",
    GetActivationCode: "獲取激活碼",
    CheckYourTravelPlans: "檢查您的旅行計劃",
    Great: "好極了！您選擇了我們的其中一個最超值航班。",
    BookTicketsNow: "機會不容錯過，趕快訂票吧！",
    TheMostValue: "最超值",
    ContinueToReserve: "繼續預定",
    BookingWithin24Hours: "預定完成24小時內，",
    freeCancellation: "可免費取消！",
    SaveTheOrder: "保存該訂單",
    ItinerarySummary: "行程摘要",
    flight: "航班",
    TaxesAndDues: "稅費",
    ReservationFee: "預定費",
    TravelInTotal: "行程總計：",
    ThePriceIsQuotedInDollars: "價格以港幣報出",
    ImportantFlightInformation: "重要的航班信息",
    RefundableAirTicket: "機票可退款",
    ChangeTheFlight: "更換航班",
    lockInThePrice: "鎖定價格 - 只需幾分鐘！",
    noPrice: "直至完成預定之前都無法保證價格。",
    original_price: "原價：",
    after24Hours: "24小時后，",
    followThe: "需遵守標準的機票規定",
    theLogonAccount: "登陸賬號可加快預定速度",
    E_mail: "電子郵箱地址",
    login: "登录",
    whoGoingTravel: "誰要去旅行？",
    thePassengerS:
      "旅客姓名必須與政府簽發的帶有本人照片的證件上所示的完全一致。",
    mainContactPerson: "（主要聯繫人）",
    name: "名字",
    middleName: "中間名",
    familyName: "姓氏",
    dateOfBirth: "出生日期",
    codicePaese: "國家/地區編碼",
    receiveSMSalerts:
      "接收關於本次行程的短信提醒。可能會收取短信和數據服務費。",
    frequentFliers: "常旅客等",
    frequentFlyer: "常客計劃",
    SchemeNo: "計劃編號",
    PleaseSelect: "請選擇",
    weWillInform:
      "我們會將計劃詳細信息告知航空公司，然而無法保證一定獲取積分獎勵。",
    emergencyContactName: "緊急聯繫人姓名",
    creditCard: "信用卡",
    CardholderName: "持卡人姓名",
    CCNumber: "信用卡卡號",
    month: "月",
    year: "年",
    safetyCode: "安全碼",
    CountryRegion: "國家/地區",
    billingAddress1: "賬單地址1",
    billingAddress2: "賬單地址2",
    County: "縣/省/市/自治區",
    EmailAddressCoding: "郵箱編碼",
    whereMail: "我們應該講您的確認郵件發送到哪裡？",
    pleaseEnterEmail: "請輸入希望接收確認信息的電子郵件地址。",
    createAnaccount: "創建賬戶，不僅付款更快，還能方便地查看行程。",
    useTheAboveEmailAddress: "使用以上電子郵件地址，輸入密碼創建賬戶。",
    CreatePassword: "創建密碼",
    passwordLimif: "（包含 6 到 30 個字符，不包含空格）",
    confirmPassword: "確認密碼",
    determineAndScheduleYourTrip: "確定並預約行程",
    agreeToObey: "我已閱讀並同意遵守",
    UniversalServiceAgreement: "Trip 用戶服務協議",
    AgreementRegistration: "同意協議並註冊",
    retrieveThePassword: "找回密碼",
    retrieve: "找回",
    PleaseEterPhoneNumber: "請輸入電話號碼",
    ClickGetCode: "點擊獲取驗證碼",
    nextStep: "下一步",
    emails: "電子郵件",
    resetPassword: "重置密碼",
    cipherStrength: "密碼強度",
    weak: "弱",
    center: "中",
    strong: "強",
    PleaseEnterAgainPassword: "請再次輸入登錄密碼",
    confirm: "確認",
    userProtocol: "用戶協議",
    serviceSupport: "服務支持",
    disclaimer: "網站使用條款",
    privacyPolicy: "隱私政策",
    hongkongWuzhou: "香港五洲國際旅遊有限公司",
    JinlunMansion: "香港九龍長沙灣荔枝角道838號曆豐中心12樓1201室",
    companyName: "樂遊五洲國際旅遊（深圳）有限公司",
    companyAddress: "深圳市羅湖區黃貝街道新秀社區沿河北路1002號瑞思塔樓A座31樓",
    recordNumber: "粵ICP備2020076261號-5",
    cooperativePartner: "合作夥伴",
    russia: "俄羅斯",
    hotSeason: "當季熱門",
    canada: "加拿大",
    newYork: "紐約",
    HongKong: "香港",
    TodayDeal: "今日特價",
    //TodayDeal:"11.11特惠",
    TodayDealMark: "雙11期間HKG-BKK/TPE航線全線8折起",
    customerServiceHotline: "客服熱線",
    listeningYourVoice: "您的聲音我們用心在聽",
    ServiceMailbox: "服务邮箱",
    lookEachYourLetters: "認真查看，你們的每一封來信",
    feedback: "意見反饋",
    ProfessionalTeam: "專業團隊，24小時急速跟進",
    ClickSubmission: "點擊提交",
    NoviceGuide: "新手上路快速引導",
    becomeMemberQuickly: "還不是會員，如何快速成為會員",
    becomeMember: "如何成為環球行會員",
    Reservations: "預訂機票",
    thirdPartyAccounts: "如何通過第三方賬號登錄",
    PayRelatedIssues: "支付相關問題",
    More: "更多",
    Onlinepayment: "在線付款",
    Paymentsecurityandoptions: "付款安全和選項",
    Refundtimelimit: "退款時限",
    Howtobuyinsurance: "誤機？",
    Changeandrefund: "改簽和退票",
    Baggageamount: "行李額",
    Addnewpassengers: "添加新旅客",
    Passwordmodification: "密碼修改",
    AccountRelatedHelp: "賬戶中心相關幫助",
    BindingCardHelp: "綁卡相關幫助",
    PayRelatedHelp: "支付相關幫助",
    RefundRelatedHelp: "退款相關幫助",
    AirlineTicketRelated: "機票相關",
    buyChildTicket: "如何購買兒童票",

    HowInternationalTicketsPay: "國際機票如何支付票款",
    MembershipService: "會員服務",
    MemberDataManagement: "會員資料管理",
    PasswordCuery: "密碼查詢",
    MembershipRegistration: "會員註冊",
    unsubscribe: "註銷賬戶",
    ClickBindings: "點擊綁定",
    ThankYouForUsingIt: "非常感謝您使用",
    welcomeToTellUs:
      "如果您有任何建議，歡迎您來告訴我們,您的意見將幫助我們改進產品和服務",
    AccountNumber: "賬號",
    PleaseSelectProduct: "(請選擇一個產品分類以幫助我們確認問題)",
    ContactName: "聯系姓名",
    Contact: "聯系",
    shouji: "手機號碼",
    ItCanBeEntered: "還可以輸入",
    word: "字",
    content: "內容",
    Submission: "提交",
    PleaseDescribeYourSuggestions:
      "請您盡可能具體的描述您對我們的建議，這將能夠更好的幫助我們改進產品和服務",
    ConcessionCode: "優惠碼",
    PleaseConcessionCode: "請輸入優惠碼",
    ConfirmationClaim: "確認領取",
    ConcessionCode: "優惠碼明細",
    AmountAvailable: "可用金額",
    element: "(元)",
    AvailableNumber: "可用個數",
    individual: "(個)",
    NoCoupons: "暫無優惠券",
    inUse: "使用中",
    operation: "操作",
    state: "狀態",
    balance: "余额",
    Denomination: "面額",
    ExpiryTime: "過期時間",
    ReceiveTime: "領取時間",
    CardNumber: "卡號",
    NameChen: "名稱",
    Expired: "已過期",
    haveBeenExhausted: "已用完",
    Available: "可使用",
    whole: "全部",
    enterTheProblems: "輸入您所遇到的問題 我們幫您解決",
    HotSearch: "熱門搜索",
    purchase: "購買",
    PlaneTicket: "機票",
    InternationalTicket: "國際機票",
    allowanceInternationalRoutes: "請問國際航線免費行李額有哪些規定",
    international: "(國際)",
    twoKindsWeight:
      "國際航線免費行李額分別為計重免費行李額和記件免費行李額兩種",
    /*
    FreeBaggageAllowance:"計件免費行李額：按照旅客所付的票價座位等級，每一全票或半票旅客免費行李額為兩件, 每件的長寬高三邊之和不得超過158厘米",
    BecauseEachAirline:"因每條航線及航空公司規定不統一，具體情況以您咨詢航空公司和代理商為準",
    inch:"英寸",
    Pound:"鎊",
    TheWeightEachPieceShall:"每件重量不得超過32公斤。但持有經濟艙(包括旅遊折扣)客票的旅客，其兩件行李長寬高的總和不得超過273厘米",
    NoFreeBaggageAllowance:"按成人全票價百分之十購買的嬰兒無免費行李額",
    accordingToTheFareAndSeat:"計重免費行李額：按照旅客所付的票價座位等級，每一全票或半票旅客免費行李額為：頭等艙為40公斤",
    TheBusinessClassIs30Kilos:"公務艙為30公斤",
    EconomyAClass:"經濟艙(包括旅遊折扣)為20公斤",
    */
    weightFreeBaggageAllowance:
      "計重免費行李額：按照旅客所付的票價座位等級，每一全票或半票旅客免費行李額為：頭等艙為40公斤（88鎊），公務艙為30公斤（66鎊），經濟艙（包括旅遊折扣）為20公斤（44鎊），按成人全票價百分之十購買的嬰兒無免費行李額",
    freeBaggageAllowance:
      "計件免費行李額：按照旅客所付的票價座位等級，每一全票或半票旅客免費行李額為兩件，每件的長寬高三邊之和不得超過158釐米（62英寸），每件重量不得超過32公斤。但持有經濟艙（包括旅遊折扣）客票的旅客，其兩件行李長寬高的總和不得超過273釐米（117英寸），按成人全票價百分之十購買的嬰兒無免費行李額 ",
    BecauseEachAirline:
      "因每條航線及航空公司規定不統一，具體情況以您咨詢航空公司和代理商為準",

    MyPoints: "我的積分",
    branch: "分",
    QueryTime: "查詢時間",
    TheLastMonth: "最近一個月",
    ThreeMonths: "三個月",
    AYear: "一年",
    ScreeningConditionsEmptying: "清空篩選條件",
    IntegralName: "積分類型",
    GenerationTime: "產生時間",
    income: "操作類型",
    expenditure: "數額",
    abstract: "摘要",
    Remarks: "備註",
    AddMailingAddress: "添加",
    XingMing: "姓名",
    ChineseEnglish: "姓名",
    areaLocated: "所在地區",
    DetailedAddress: "詳細地址",
    ZipCode: "郵編",
    CellPhoneNumber: "手機號",
    modify: "修改",
    delete: "刪除",
    DeleteInformation: "刪除信息",
    EssentialInformation: "基本信息",
    ReturnToTheUserList: "返回用戶列表",
    Location: "所在地",
    SelectProvince: "選擇省",
    ChooseUrbanArea: "選擇市區",
    SelectedAreaCounty: "選擇區/縣",
    EnterDetailedAddress: "請輸入詳細地址",
    PostalCode: "郵政編碼",
    PleaseEnterZipCode: "請輸入郵政編碼",
    Preservation: "保存",
    cancel: "取消",
    addressManagement: "郵寄地址管理",
    CommonPassengerManagement: "常用旅客管理",
    AddingCommonlyUsed: "添加常用旅客信息",
    DocumentType: "證件類型",
    IdentificationNumb: "證件號碼",
    AirlineCard: "航司卡",
    TypeOfPassenger: "旅客類型",
    MailingAddress: "郵寄地址",
    BasicInformation: "基礎信息",
    ReturnListPage: "返回列表頁",
    nameMustBeFilled: "中文名字和英文名字必須填一個",
    keepItSafePassword: "登錄賬戶時需要輸入登錄密碼，請妥善保管",
    oldPassword: "當前密碼",
    NewPassword: "新密碼",
    EnterNewPassword: "輸入新密碼",
    EnterPassWordAgain: "再次輸入密碼",
    ConfirmationModification: "確認修改",
    ForgetLoginPassword: "忘記登錄密碼",
    man: "男",
    woman: "女",
    SystemMessage: "系統消息",
    news: "消息",
    AllMarkedRead: "全部標記為已讀",
    strip: "條",
    RefundStatusMessage: "退款狀態消息",
    purchaseSuccessful: "您於2018-9-18 00:15購買的深圳-南昌機票訂單退款成功",
    ViewTheDetails: "查看详情",
    ChinaName: "中文名",
    EnglishName: "英文名",
    AddDocuments: "添加其他證件",
    errorMessages: "請更正下面的錯誤",

    coin: "無特殊要求",
    showNum: "1位成人， 0名兒童",
    showNumFirst: "位成人,",
    showNumLast: "名兒童",
    preferredSeat: "經濟艙",

    fromCityIsNotNull: "出發城市不能爲空",
    returnCityIsNotNull: "到達城市不能爲空",
    fromTimeIsNotNull: "出發時間不能爲空",
    returnTimeIsNotNull: "返程時間不能爲空",
    returnTimebyFrom: "返程時間不能在出發時間之前",

    searchErrorMessage: "查詢失敗，請重試",

    areyousure: "確定刪除嗎？",

    logout: "退出",
    cabinName: "艙等",

    predeterminedPromptOne:
      "請查看您的詳細旅行資訊，以確保日期和時間正確無誤。",
    predeterminedPromptTwo:
      "請檢查您的拼寫。班機乘客姓名必須與政府簽發的帶有本人照片的身份證件上所示的完全相符，如因拼寫錯誤造成退款我們將收取一定手續費。",
    predeterminedPromptThree: "查看預訂條款：",
    predefinedClauseOne:
      "我們理解您的出行計畫有時會發生變更。我們不收取消或變更費用。如果航空公司按照其內部政策規定收取此類費用，則這部分費用將由您承擔。",
    predefinedClauseTwo: "機票可以退款。",
    pleaseRead: "請閱讀",
    regulationAndCharterContract: "變更和取消手續費規定全文或包機契约 ",
    period: "。",
    airlinesLimitationClause: "航空公司責任限制方面的重要資訊",
    predefinedClauseThree: "價格可能不包含航空公司直接收取的行李費或其他費用。",
    predefinedClauseFour: "出票前不能保證票價不發生變更 。",
    predefinedClauseFive:
      "禁止在通過行李中夾帶或是隨身的管道攜帶任何危險品登機。",

    readAndAgree: "選擇完成該預訂即表示，您確認已閱讀並接受上述規則和限制、",
    termsAndConditions: "使用條款",
    privacyStatement: "隱私政策",
    tourSuggestion: "政府旅遊建議",
    and: "和",
    regulationsMentionedAbove: "",
    Renewyourpassport: "更新護照",
    acceptAndContinue: "完成預定",
    informationSecurely: "",

    oneWayTicket: "單程機票",
    roundTripTicket: "往返機票",
    paymentSuccess: "支付成功!",
    toMyTicket: "去我的行程中查看",
    waitPatiently: "目前正在出票，請您耐心等待，我們將在30分鐘內簡訊通知。",

    registerWithMailbox: "切換郵箱註冊 ",
    registerWithPhoneNumber: "切換電話號碼注册",
    logoutSuccessful: "註銷成功",
    jumpHome: "跳轉首頁",
    logIn: "請登入",
    accountNotExist: "帳號不存在 ",
    kindlyReminder: "溫馨提示：",
    issuedWithin48hours: "預計訂單提交24小時內完成出票!",
    expiryDate: "證件有效時間",
    issuingCountry: "證件發行國家/地區",
    airlineName: "航司名",
    airlineCardNumbers: "航司卡號",
    loading: "加載中",
    frequency: "次",
    timeStop: "次經停",
    nonStopFlight: "直飛",
    conversionTimeDifference: "注意：轉換時差後得到的時間",
    includingTaxes: "含稅費",
    airline: "航司",
    newFightNumbers: "航班號",
    carrier: "實際承運航司",
    fightNumbers: "實際航班號",
    forFree: "免費",
    forFree20kg: "20公斤以內免費",
    stay: "停留",
    estimate: "預計到達時間：",
    //arrive:"到達",
    pricesQuotedHKD: "價格以港幣報出",
    logInAsVisitor: "以遊客身份登入",
    passwordChangedSuccessfully: "密碼修改成功",
    logInWithNewPassword: "您已成功設置密碼，請試用新密碼登陸",
    emailUnregistered: "郵箱未注册",
    phoneNumberUnregistered: "手機號碼未注册",
    unregistered: "未注册",
    phoneNumberError: "手機號格式錯誤",
    phoneNumberCannotEmpty: "手機號不能為空",
    emailError: "郵箱格式錯誤",
    emailCannotEmpty: "郵箱不能為空",
    passwordConfirmError: "兩次密碼輸入不一致，請重新輸入 ",

    firstNameCannotEmpty: "請只使用拼音輸入名字",
    middleNameCannotEmpty: "請只使用拼音輸入中間名",
    lastNameCannotEmpty: "請只使用拼音輸入姓氏",
    selectSex: "請選择性別",
    selectCountry: "請選择國籍",
    selectBirthday: "請選择有效的出生日期",
    ageCannotEmpty: "請輸入正確的年齡",
    selectCredentialsType: "請選择證件類型",
    passportCannotEmpty: "請輸入有效的證件號碼",
    selectCardExpired: "請選择證件有效時間",
    selectCardIssuePlace: "請選择證件發行國家",
    selectMobilePrefix: "請選择國家/地區編碼",
    selectRegPhoneZone: "請選择國家/地區",

    firstClass: "頭等艙",
    businessClass: "商務艙",
    premiumEconomyClass: "高端經濟艙",
    economyClass: "經濟艙",

    determine: "確定",
    //免责申明
    disclaimerDetails:
      "此網站上公佈的資訊、軟件、產品及服務可能存在誤差或錯誤，包括價格錯誤。特別要指出的是，Trip公司以及Trip合作夥伴不保證本網站上顯示的班機及其他旅行產品和服務的資訊和描述（包括但不限於定價、照片、一般產品描述等）的正確性，也不對與此類資訊和描述相關的任何錯誤或其他誤差承擔任何責任。此外，Trip明確保留糾正我們網站上的任何定價錯誤和/或按照錯誤價格進行的預訂的權利。在此類情况下，如果沒房，則我們將為您提供按正確價格保留您預訂的機會，否則我們將取消您的預訂且免收囙此產生的罰金。             Trip公司、Trip合作夥伴及其各自的供應商不對本網站上所包含的資訊、軟件、產品和服務針對任何目的的適用性做任何聲明；在本網站上包含或提供任何產品或服務不構成Trip公司或Trip合作夥伴對此類產品或服務作出的任何認可或推薦。所有此類資訊、軟件、產品及服務均“按原樣”提供，不含有任何保證。" +
      "Trip公司、Trip合作夥伴及其各自的供應商拒絕承認任何擔保及條件，即本網站、網站服務器或Trip公司、Trip合作夥伴和/或其各自的供應商所發送的任何電子郵件不含病毒或其他有害組件。Trip公司、Trip合作夥伴及其各自的供應商在此拒絕承認與此資訊、軟件、產品和服務有關的所有擔保及條件，包括所有對適銷性、特定用途適用性、產權和非侵權性的默示擔保及條件。             在本網站上提供旅行服務或其他服務的承運商、飯店及其他供應商為獨立的立約方，並非Trip公司或Trip合作夥伴的代理或員工。Trip公司和Trip合作夥伴不對任何此類供應商的行為、錯誤、失職、聲明、擔保、違規或疏忽負責，也不對由此造成的任何人身傷害、死亡、財產損害或由此產生的其他損害或費用負責。如果發生延遲、取消、過量預訂、罷工、不可抗力或其他超出直接控制範圍之事由，Trip公司和Trip合作夥伴不承擔任何責任且不予退款，並且不對任何額外費用、失職、延遲、重新安排路線或任何政府或機构的行為負責。             對於您訪問、展示或使用本網站引起或與此相關，或與延遲或無法訪問、展示或使用本網站相關的任何直接、間接、懲罰性、附帶性、特殊或後果性損害賠償（包括但不限於您對本網站上的觀點的依賴；任何電腦病毒、資訊、軟件、連結的網站、通過本網站獲取的產品和服務；或由訪問、展示或使用本網站引起），Trip公司、Trip合作夥伴和/或其各自的供應商在任何情况下均不承擔責任，不論是基於過失論、合約、侵權、嚴格責任、消費者保護法或其他，且即使在Trip公司、Trip合作夥伴和/或其各自的供應商已被告知該類損害賠償的可能性的情况下也是如此。             儘管有以上規定，但如果Trip公司、Trip合作夥伴或其各自的供應商被認定對由任何上述情形引起或與之相關的任何損失或損害負有責任，則Trip公司、Trip合作夥伴和/或其各自的供應商的責任在任何情况下總計不得高於以下費用中的較高者：（a）您為本網站上的此類交易向Trip支付的服務費用，或（b）一百美元（US$100.00）或以當地貨幣計算的等值金額。     " +
      "        責任限制反映了雙方之間的風險分配。如果本使用條款所述的任何有限補救未能達到其基本目的，本節所述限制將繼續有效並適用。本使用條款規定的責任限制有利於Trip公司、Trip合作夥伴和/或其各自的供應商。",

    privacyPolicyOne: "Trip Trip隱私政策 ",
    privacyPolicyTwo:
      "下文是Trip 更新後的隱私政策。我們非常重視您對我們的信任，並將確保您提供給我們的個人資訊的安全性和機密性作為工作的重中之重。請閱讀此政策，瞭解我們的隱私保護做法。訪問本網站即表示您接受此處描述的做法。 ",
    privacyPolicyQ1: "我們收集您的哪些資訊",
    privacyPolicyQ2: "我們如何使用您的資訊",
    privacyPolicyQ3: "我們與誰共亯您的資訊",
    privacyPolicyQ4: "您如何訪問自己的資訊",
    privacyPolicyQ5: "您在您的資訊受到收集和使用方面有何選擇",
    privacyPolicyQ6: "Cookie和其他科技",
    privacyPolicyQ7: "顯示定制廣告/您的選擇",
    privacyPolicyQ8:
      "使用Trip 手機和平板電腦應用（以下簡稱“移動應用”）",
    privacyPolicyQ9: "我們如何保護您的資訊",
    privacyPolicyQ10: "兒童的隱私",
    privacyPolicyQ11: "外部連結",
    privacyPolicyQ12: "對本隱私政策的變更",
    privacyPolicyQ13: "您如何聯繫我們",

    privacyPolicyAnswer1_1:
      "一般資訊。我們會收到並存儲您在我們網站上輸入的或者以其他任何管道提供給我們的所有資訊。這包括能够識別您身份的資訊（以下簡稱“個人資訊”），包括您的姓氏和名字、電話號碼、郵寄地址、電子郵寄地址，以及付款資訊（如信用卡卡號、持卡人姓名和到期日期）。我們還可能要求您提供有關飯店房間偏好、常客和租車計畫的資訊。您可以選擇不向我們提供資訊，但是您通常需要提供一些個人資訊才能注册為會員、預訂旅行、填寫旅客資料，參加調查、比賽或抽獎，向我們提問，或者在我們的網站開展其他交易。",
    privacyPolicyAnswer1_2:
      "旅伴資訊。如果您通過本網站為其他人預訂，我們將要求您提供該旅客的個人資訊和旅行偏好。您向我們提供該旅客的個人資訊和旅行偏好之前，應先征得其本人的同意，這是因為只能通過您的賬戶查看或更改其資訊。",
    privacyPolicyAnswer1_3:
      " 從其他來源獲得的資訊。我們也會定期從關聯實體、業務合作夥伴和其他獨立協力廠商來源獲得您的個人資訊和非個人資訊，並將這些資訊添加到我們的賬戶資訊中。我們可能收到的資訊包括：最新的配送和地址資訊、購買歷史記錄和人口統計資訊。" +
      "此外，如果您使用自己的社交媒體賬戶注册Trip、將您的Trip 賬戶關聯至社交媒體賬戶，或者使用某些其它Trip 的社交媒體功能，我們可能會依照此類社交媒體提供商的政策訪問您的資訊。這些資訊可能包括您的姓名、電子郵寄地址、個人資料照片、性別、朋友清單，以及您授權我們接收的其它資訊。依據您和您朋友的隱私設定，我們可能會訪問您提供給社交媒體提供商的各自位置資訊（以下簡稱“位置數據”），以便為您提供相關內容。請注意，依據您在此類社交媒體提供商的隱私設定，您的位置數據也可能會在社交媒體提供商中與您的朋友共用。",
    privacyPolicyAnswer1_4:
      "自動收集資訊。當您訪問本網站時，我們會自動收集有關有關您的電腦的一些資訊。例如，我們會收集您的IP地址、Web瀏覽器軟件（如Firefox、Safari或Internet Explorer）以及推介網站。我們還可能會收集有關您的線上活動的資訊，如查看的旅行和進行的預訂。我們自動收集這些資訊的目的是幫助定制您的用戶體驗和避免欺詐。",
    privacyPolicyAnswer1_5: "要瞭解更多資訊，請參閱Cookie和其它科技。",
    privacyPolicyAnswer2_1:
      "我們使用敏感的付款資訊（如持卡人姓名、信用卡卡號和到期日期）以便完成您在我們網站上進行的旅行預訂。我們將您的其它資訊用於下述一般目的：向您提供您申請的產品和服務；向您提供旅行確認和更新；管理您的賬戶，包括處理帳單和提供旅行通知；與您進行一般性溝通；答覆您的疑問和評論；衡量興趣度以及改善我們的產品、服務和網站；通知您可能感興趣的特價以及產品或服務；在其它方面自定您在本網站的體驗；在您選擇參加的任何獎勵和認同計畫中作為一部分給您的獎勵；從您那裡徵求資訊，包括通過調查的管道；解决爭議、收取費用或解决問題；防範潜在禁止的或非法的活動；實施我們的使用條款；以及收集資訊時向您描述的其它目的。",
    privacyPolicyAnswer2_2:
      "電子郵件通信。我們希望您能够輕鬆地利用我們網站上提供的旅行相關機會。為此，我們採取的其中一種方法是向您發送電子郵件，在郵件中為您提供您會明顯感興趣的旅行相關資訊。例如，如果您在我們網站上蒐索前往紐約的班機，並保存了您的行程或者尚未預訂旅行，那麼我們會向您發送電子郵件，提醒您已保存的行程或前往紐約的優惠機票。同樣，如果您在收到有關紐約旅行的電子郵件後，告知您可通過我們網站獲得與旅行相關的特價產品。請注意，在我們發送的任何此類電子郵件中，您都有機會選擇不接收這些電子郵件。“請查閱下方的“您在資訊收集和使用方面的選擇”。",
    privacyPolicyAnswer3One: "本網站可能會將您的資訊與下述實體共亯：",
    privacyPolicyAnswer3Two:
      "供應商，即您提供旅行預訂項目的供應商，如航空公司和活動提供商。在本網站，所有由協力廠商供應商提供的服務都如實描述。通過本網站預訂即表示您授權我們向供應商披露所需的資訊，以便完成預訂和提供相關旅行。這些供應商不受Trip Trip的控制，向他們披露的個人資訊受相應供應商的適用隱私政策和安全保護做法的約束。囙此，如果您通過本網站購買任何旅行供應商的產品，我們建議您查看其隱私政策。",
    privacyPolicyAnswer3Three:
      "協力廠商供應商，即代表我們提供服務或職能的供應商，包括信用卡處理、業務分析、客戶服務、行銷、分發調查或抽獎計畫，以及預防欺詐。我們也可能授權協力廠商供應商代表我們收集資訊，包括用於運作我們網站的功能或者便於交付根據您的興趣定制的線上廣告所必需的資訊。協力廠商供應商只能根據履行職能所需訪問資訊和收集資訊，不得出於任何其他目的共亯或使用資訊。他們還需遵循我們所遵守的相同數據安全保護做法。",
    privacyPolicyAnswer3Four:
      "業務合作夥伴，我們可能與他們聯合提供產品或服務，也可能在我們的網站提供他們的產品或服務。當協力廠商參與提供您所請求的產品或服務時，您會看到他們的名稱單獨顯示，或者與我們的名稱一起顯示。如果您選擇訪問這些可選服務，我們可能會與這些合作夥伴分享您的資訊，包括您的個人資訊。需要注意的是，我們無法控制這些協力廠商業務合作夥伴的隱私保護做法。",
    privacyPolicyAnswer3Five:
      "推介網站。如果您是經其他網站推薦後訪問本網站的（例如，通過點擊其它網站的連結直接轉至本網站），我們可能與該推介網站共亯您的部分資訊。我們尚未對推介網站使用您的個人資訊做出任何限制，囙此我們鼓勵您查看推薦您訪問本站的任何推介網站的隱私政策。",
    privacyPolicyAnswer4:
      "如需訪問和更新您的聯系資訊，請訪問本網站的“個人資訊”頁面。如需註銷賬戶，請按下述電子郵寄地址向我們發送電子郵件。請注意，在註銷賬戶後，您將無法登入或訪問您的任何個人資訊。不過，您可以隨時新開賬戶。另請注意，我們可能會將您的賬戶的某些關聯資訊保留一段時間，用於分析以及保持記錄完整性等目的。",
    privacyPolicyAnswer5:
      "如上所述，您可以選擇不向我們提供任何資訊，儘管可能需要這些資訊以預訂旅行或使用本站提供的某些功能。             您也可以如上文所述添加或更新資訊，並可以註銷賬戶。             您將有機會在我們發送的任何資訊中從商業電子郵件選擇取消訂閱。如果您是註冊會員，您還可以隨時在“個人資訊”頁面修改您的選擇。請注意，我們保留向您發送其他通信的權利（包括與您的賬戶或您在本站的交易相關的服務通知、管理資訊及調查），並且不給予您拒收這些通信的機會。             您有機會在我們的網站上提供手機號碼，以便接收旅行當日班機提醒。您隨時都可以中止這些提醒。             在大多數瀏覽器中，工具列的“幫助”部分都會告訴您如何封锁瀏覽器接受新的Cookie，如何設定瀏覽器以便在收到新Cookie時發出通知，或者如何完全禁用Cookie。請注意，如果您拒絕接受本站發送的Cookie，則將無法訪問我們網站上的某些內容。",

    privacyPolicyAnswer6One:
      "Cookie是小的數據文字檔，可以存儲在您電腦的硬體驅動器中（如果您的網頁瀏覽器允許）。本網站的Cookie用於以下一般目的：",
    privacyPolicyAnswer6Two:
      "為了幫助我們識別出您的瀏覽器為此前的訪問者，請保存並記住您的瀏覽器訪問我們網站時曾設定的任何偏好。舉例來說，如果您在我們的網站註冊，則我們會用Cookie記住您的注册資訊，這樣您每次訪問我們網站時就不需要登入。如果您勾選了“Sign me in automatically next time”（下次自動登錄）核取方塊，我們還可能在Cookie中記錄您的密碼。請注意，出於安全目的，此類Cookie中所包含的會員ID、密碼以及任何其它賬戶相關資料都是加密的。除非您在我們這裡注册，否則這些Cookie中將不會包含任何個人資訊。",
    privacyPolicyAnswer6Three:
      "目的是為了幫助我們定制本網站和互聯網其它網站提供給您的內容和廣告。例如，當您訪問我們的網站時，我們、我們的服務提供者或者我們的合作方會自動創建cookie，以便您在互聯網上瀏覽時識別您的瀏覽器，根據您表現出的偏好向您推送資訊和廣告。如欲詳細瞭解我們的線上廣告做法和您的選擇，請參閱廣告顯示/您的選擇。",
    privacyPolicyAnswer6Four:
      "目的是為了幫助我們衡量和研究網站功能以及產品、服務、廣告和電子郵件通信（通過確定您打開了哪些電子郵件並做出行動）的有效性。",
    privacyPolicyAnswer6Five:
      "在大多數瀏覽器中，工具列的“幫助”部分都會告訴您如何封锁瀏覽器接受新的Cookie，如何設定瀏覽器以便在收到新Cookie時發出通知，或者如何完全禁用Cookie。請注意，如果您拒絕接受Cookie，則可能無法訪問我們網站提供的許多旅行工具。",
    privacyPolicyAnswer6Six:
      "除了上述Cookie之外，我們還在網站上使用本地共亯對象（也稱作“Flash Cookie”）。它們通過存儲您的用戶首選項和設定（如您的音量/靜音設定），並關聯我們網站上的動畫內容，力求改善您的用戶體驗。本地共亯對象與瀏覽器Cookie相似，但可以存儲比簡單文字更複雜的數據。它們自己無法對您的電腦上的數據執行任何操作。與其他Cookie一樣，它們只能訪問您在本網站上提供的個人身份識別資訊，而且其他網站無法訪問它們。如欲瞭解有關Flash Cookie的更多資訊或者其禁用方法，請訪問：http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager.html. 本網站還可能使用Web信標（也稱作透明GIF、點數標籤或網路爬蟲），它們是放置在網頁程式碼中帶有唯一識別字的微小圖形，功能與Cookie類似。我們使用Web信標監控用戶從我們網站內的一個頁面轉到另一個頁面的流量模式，使用Cookie提供內容或進行通信，瞭解您是否從協力廠商網站顯示的線上廣告轉到我們網站，以及增强網站效能。我們還可能允許服務提供者使用Web信標，以幫助我們瞭解收件人打開過哪些電子郵件並跟踪我們網站上的訪客流量和操作。這有助於我們衡量我們的內容和其他產品的效力。",
    privacyPolicyAnswer6Seven:
      " 如果您對我們的Cookie或其他科技的用途有任何疑問，請通過電子郵件向我們發送客戶服務和回饋表。",
    privacyPolicyAnswer7_1:
      "本網站利用所收集的數據向您提供相關廣告。Trip 致力於為您提供相關內容和資訊。為此，我們可能會通過Cookie和其它科技收集您的旅遊相關搜索資訊，比如您是否查找航空公司航線或飯店。我們利用這一資訊，連同我們收集的您的其它相關資訊，在我們的網站或者網上其它地方為您推送與您的興趣相匹配的廣告。囙此舉例來說，如果您在本站搜索前往佛羅里達的班機，則您可能在本站或者訪問的其它網站上看到佛羅里達旅行套餐的廣告。請注意，我們不會把收集的您在本網站查找到的旅行相關搜索結果與您的個人資訊（如電子郵寄地址）相結合，以便在其它網站推送廣告。我們也不會與協力廠商共亯您的個人資訊，以便它們推送廣告。您可以在其它網站上選擇不接收根據您在本網站進行的旅行相關搜索而定制的線上廣告。請注意，如果您選擇不接收定制廣告，您仍將看到線上廣告，只是它們將更一般化且與您的關聯更少。業務合作夥伴和廣告網絡利用所收集的數據向您提供相關廣告。",
    privacyPolicyAnswer7_2:
      "您在本網站看到的廣告是由我們或我們的服務提供者提供的。不過，我們也允許協力廠商通過Cookie和其他科技收集您的線上活動相關資訊。這些協力廠商包括（1）業務合作夥伴（當您查看他們投放在我們網站的某個廣告或與該廣告互動時，他們會收集資訊）；以及（2）廣告網絡（當您查看他們投放在Internet的很多不同網站上的某個廣告或與該廣告互動時，他們會收集有關您的興趣的資訊）。這些協力廠商收集的資訊用於預測您的性格、興趣或偏好，以及在我們的網站及互聯網上根據您顯露的興趣展示定制廣告。我們不允許協力廠商在我們的網站收集您的個人資訊（如電子郵寄地址），也不會與他們共亯您的任何個人資訊。",
    privacyPolicyAnswer7_3:
      " 請注意，我們無法訪問或控制這些協力廠商在收集有關您的興趣資訊時可能會使用的Cookie或其他科技，也無法訪問或控制不屬於本隱私政策範圍的協力廠商資訊處理做法。這些公司中有一些是網路廣告促進協會的會員，這個機构為人們提供了可以選擇不接受會員公司廣告的機會。要瞭解更多資訊，請按一下此處或此處。“請勿跟踪”訊號和類似機制。一些網絡瀏覽器可能會向與瀏覽器通信的網站傳輸“請勿跟踪”訊號。由於網絡瀏覽器綜合和啟動這一功能的方法存在差异，囙此有時我們並不清楚用戶是否有意傳送這些訊號，或者是否意識到它們存在。領先的互聯網標準設定組織的參與者正在解决這一問題，他們正在確定接收到此類訊號時哪些（如果有）網站應這樣做。現時，Trip Trip不會對這些訊號做出應對行動。如果有最終標準，並且最終標準已確立並被廣泛接受時，我們將重新評估應如何應對這些訊號。",
    privacyPolicyAnswer8:
      "當您使用Trip 移動應用時，我們會像您在使用我們的網站時一樣，以相同的管道並出於相同的目的收集和使用您的資訊。             除此之外，我們還會使用我們在您使用我們的移動應用時自動收集的某些其他資訊。具體來說：             我們會收集您訪問和使用的移動應用功能的資訊。通過這些資訊，我們可確定客戶對移動應用的哪些部分感興趣，進而能完善和不斷改善移動應用。但是，我們無法通過出於此目的而收集的資訊直接識別您的身份。             每個移動應用也會向我們發送設備的唯一設備識別字（即“UID”），該識別字由一串數位或字元組成，對您的移動設備具有唯一性。我們僅在客戶首次打開移動應用時使用此識別字，以便我們能够向我們的廣告網絡確認按一下他們的相應廣告橫幅和其他行銷工具所帶來的下載量。             使用移動應用時，您可以選擇允許移動應用訪問您的當前位置（此位置由移動設備利用GPS或類似技術提供），以便發現附近的飯店或機場。如果選擇允許移動應用訪問當前位置，此位置數據可能會以匿名形式收集，並作為我們的服務器記錄的蒐索請求的一部分。您可以隨時通過手機設定選單，關閉移動應用對您所處位置的訪問。             每個移動應用也會在崩潰或掛起時向我們發送錯誤報告資訊。此類資訊有助於我們調查錯誤原因，並改善未來發佈的移動應用的穩定性。移動應用向我們發送的這些錯誤報告中包括移動設備類型和版本、UID、錯誤發生時間、錯誤發生時正在使用的功能以及應用程序狀態的資訊。除了調查並修復錯誤外，我們不會將此資訊用於任何其他目的。             您始終能控制移動應用向我們發送的資訊的內容。為此，您可以更改移動應用設定選單下的設定或更改移動設備的設定。此外，您也可以從移動設備中完全删除移動應用，並通過我們的網站訪問我們的服務。",
    privacyPolicyAnswer9:
      "我們希望您能放心地使用本網站安排旅行，為此，我們將竭力保護所收集的資訊。雖然沒有哪一家網站能够保證絕對的安全，但是我們實施了恰當的管理、科技和物理安全程式，有助於保護您提供給我們的個人資訊。例如，我們僅允許獲得授權的員工訪問個人資訊，並且他們只會在履行職責時訪問個人資訊。此外，我們在您的系統和我們的系統之間傳輸您的敏感個人資訊時會使用加密技術。我們還使用防火牆和入侵偵測系統，幫助防止未授權人員訪問您的資訊。",
    privacyPolicyAnswer10:
      "這是一個面向普通受眾的網站，不提供專注兒童的服務。如果我們得知有13歲以下的兒童向我們發送個人資訊，我們只會將該資訊用於直接答覆這名兒童，告知他或她我們在接收其個人資訊之前必須獲得家長同意。",
    privacyPolicyAnswer11:
      "如果您通過本網站的任何部分連結到其他網站，這些網站的運營不受本隱私政策的約束。我們建議您查閱這些網站上張貼的隱私權聲明，瞭解它們收集、使用和披露個人資訊的程式。",
    privacyPolicyAnswer12:
      "我們今後可能會更新本隱私政策。如本隱私政策有重大變更，我們會將相關通知發送到您提供給我們的電子郵寄地址，或者在我們網站上的顯眼位置張貼通知。",
    privacyPolicyAnswer13:
      "如果您對本隱私政策（或您的旅遊計畫或購買物）有任何疑問，請通過電子郵件向我們發送客戶服務和回饋表。本隱私政策自2014年8月1日起生效。",
    backTop: "返回頂部",

    allOrders: "全部訂單",
    refundOrders: "退票訂單",
    changeOrders: "改簽訂單",
    pricesMinimum: "價格（最低）",
    pricesMaximum: "價格（最高）",
    durationMinimum: "飛行時長（最短）",
    durationMaximum: "飛行時長（最長）",
    pricesmum: "價格",
    durationmum: "飛行時長",
    departureEarliest: "去程出發時間（最早）",
    departureLatest: "去程出發時間（最晚）",
    arrivalEarliest: "去程到達時間（最早）",
    arrivalLatest: "去程到達時間（最晚）",

    returndepartureEarliest: "返程出發時間（最早）",
    returndepartureLatest: "返程出發時間（最晚）",
    returnarrivalEarliest: "返程到達時間（最早）",
    returnarrivalLatest: "返程到達時間（最晚）",

    passwordResetSuccessful: "密碼重置成功",
    skipLoginPage: "跳轉登入頁",
    retrievePasswordByEmailAddress: "切換郵箱找回",
    retrievePasswordByPhoneNumber: "切換電話找回",
    emailRegistered: "該郵箱已注册",
    phoneNumberRegistered: "該手機號已注册 ",
    imageVerificationCodeCannotBeEmpty: "圖片驗證碼不能為空",
    passwordCannotBeEmpty: "密碼不能為空",
    sentInBefore: "",
    sentIn: "後重新發送",
    registeredSuccessfully: "注册成功",
    registrationFailed: "注册失敗",
    verificationCodeError: "驗證碼錯誤",
    activationCodeError: "激活碼錯誤",
    emailRepeatError: "郵箱不能重復註冊",
    congratulations: "恭喜您",
    pleaseEnterYourEmailAddressOrPhoneNumber: "請輸入郵箱或手機號",
    passwordMustBeCharactersAndIncludeNumbersAndSymbols: "6-20位字母數字組合",
    tokenExpired: "Token過期請重新登陸",

    applyForRefund: "申請退票",
    applyForChange: "申請改簽",
    sorry: "溫馨提示",
    cannotFindTheFlight: "班機無數據",
    queryFails: "査詢失敗",
    systemError: "系統出錯啦",
    payWithin30Minutes: "請儘快支付，該訂單在30分鐘內支付有效",
    toPay: "去我的行程中支付",
    waitingForTheResultOfPayment: "等待銀行付款結果",
    toCheckOnMyItinerary: "去我的行程中査詢",

    submittedPleaseWait: "正在提交中，請稍後",
    submittedSuccessful: "提交成功",
    addAirlineCard: "添加航司卡",
    failedAvailableData: "獲取數據失敗",

    //使用协议
    useProtocol: "客戶與香港五洲國際旅遊有限公司之協議",
    useProtocolDetail1:
      "歡迎訪問 Trip 網站（以下簡稱“網站”）。網站僅用於協助客戶收集旅遊信息，確定是否有旅遊相關的商品和服務，進行合法預訂或者與旅遊供應商進行交易，除這些之外不得將本網站用於其它目的。“我們”、“我們的”、“Trip ”等詞語均指",
    fiveContinentsInternationalTravelLimited: "香港五洲國際旅遊有限公司",
    useProtocolDetail2:
      "Trip 合作夥伴”指通過其提供鏈接、內容或服務的任何聯合品牌和/或鏈接的網站。“您”一詞系指訪問本網站和/或在本網站上通過我們或我們的客服代理進行預訂的客戶。",
    useProtocolDetail3:
      "您僅可在不加修改地接受下述所有條款、條件及公告（統稱為“使用條款”或“協議”）的情況下使用本網站。",
    useProtocolDetail4:
      "請仔細閱讀這些使用條款，其中包含與責任限制和通過仲裁而非法庭解決爭議相關的重要信息。",
    useProtocolDetail5: "您還應當閱讀我們的",
    privacyPolicy: "隱私政策",
    useProtocolDetail6:
      "，該政策規定了您對本網站的使用，並通過引用納入本協議。訪問或使用本網站，在本網站預訂任何旅遊產品或服務，或與我們的客戶服務中心人員聯系，則表明您同意當時有效的使用條款適用。如果您不同意這些使用條款，請勿通過本網站或我們的客服人員進行預訂。",
    useTheSite: "使用網站",
    useTheSiteEnsure: "作為使用本網站的條件，您保證：",
    useTheSite1: "1.您至少年滿 18 周歲;",
    useTheSite2: "2.您擁有創設有約束力法律義務的法定權利;",
    useTheSite3: "3.您將遵守使用條款使用本網站;",
    useTheSite4:
      "4.您僅將本網站用於為您本人或在合法授權情況下為他人進行合法預訂;",
    useTheSite5:
      "5.您將告知上述他人適用於您代其進行預訂的使用條款，包括所有適用的規定和限制；",
    useTheSite6: "6.您在本網站上提供的信息真實、準確、最新且完整",
    useTheSite7:
      "7.如果您擁有 Trip 賬戶，您將需要保護您的賬戶信息，並對您和其他人使用賬戶進行的任何活動進行監管以及承擔完全責任。",
    useTheSite8:
      "我們保留以下權利：以任何理由（包括但不限於違反使用條款）隨時自行決定拒絕任何人訪問本網站及獲得我們提供的服務。",
    controversy: "爭議",
    controversy1:
      "Trip 致力於讓客戶滿意，因此如果您有疑問或爭議，我們會盡力為您解決問題。但是如果爭議未能得到解決，您可以按照本部分的說明申請索賠。",
    controversy2: "您同意為我們提供機會通過聯系",
    customerSupport: "客戶支持",
    controversy3:
      "， 或撥打電話 （852）3193-9788 \n" +
      "，來解決與網站、我們的客服代理進行的任何交易、提供的任何服務或產品、我們作出的任何聲明，或者我們的隱私政策（“索賠”）有任何關聯的爭議或索賠。如果我們無法在 60 天內處理索賠，您可以通過仲裁或小額訴訟法庭尋求解決，具體信息如下文所述。",
    controversy4: "除非您個人向小額訴訟法庭提出索賠並且這些法庭符合條件，",
    controversy5: "否則任何索賠都將通過具有約束力的仲裁而非法庭予以解決。",
    controversy6:
      "這包括您對我們、我們的子公司、旅遊供應商，或者對經我們提供產品或服務的公司（它們是這一仲裁協議的受益方）提起的任何索賠。這也包括您在接受這些使用條款之前提起的任何索賠，無論此前版本的使用條款是否需要仲裁。",
    controversy7:
      "仲裁中沒有法官或陪審團，並且法庭對仲裁裁決的審查有限。然而，仲裁員可以基於個人決斷做出與法庭相同的賠償和救濟裁決（包括法定賠償、律師費和花銷），並且必須與法庭一樣遵循和施行這些使用條款。",
    controversy8:
      "用於解決索賠的任何程序都將基於個案實施，不會按類別、合並或進行代表性訴訟。如果出於任何原因使得索賠程序通過法庭而非仲裁進行，我們均放棄申請陪審團審判的任何權利。仲裁決定可經由任何具備合法管轄權的法庭確認。",
    prohibitedActivities: "禁止的活動",
    prohibitedActivitiesAffirm:
      "本網站上的內容和信息（包括但不限於旅遊服務的價格和可用性）以及提供該等內容和信息所使用的基礎設施均為我們或我們的供應商和提供商的專有財產。盡管您可以對通過本網站預訂的旅行或服務的旅行計劃（及相關文檔）進行有限數量的復制，但您同意不會對本網站上提供的或通過本網站獲得的任何信息、軟件、產品或服務進行修改、復制、分發、傳播、展示、演示、再造、發布、許可、據以創作衍生作品、轉讓、銷售或轉售。另外您同意不執行以下操作：",
    prohibitedActivities1: "1.出於任何商業目的使用本網站或其內容；",
    prohibitedActivities2:
      "2.進行任何投機性、虛假或欺詐性的預訂或根據任何預測性需求進行預訂；",
    prohibitedActivities3:
      "3.未獲得我們的明示書面同意，出於任何目的、使用任何機器人軟件、爬蟲軟件、刷屏軟件或其他自動方式或任何手動流程獲取、監視或復制本網站的任何內容或信息；",
    prohibitedActivities4:
      "4.違反本網站上任何機器人排除標頭中的限制，或者繞開或回避旨在防止或限制訪問本網站的其他手段；",
    prohibitedActivities5:
      "5.實施任何導致或可能導致（由我們決定）我們的基礎設施負載過重的行為；",
    prohibitedActivities6:
      "6.未獲得我們的明示書面同意，出於任何目的深鏈接至本網站的任何部分（包括但不限於任何旅遊服務的購買路徑）；或者",
    prohibitedActivities7:
      "7.未事先獲得我們的書面授權，以“框架”、“鏡像”或其他方式在任何其他網站中包含本網站的任何部分。",
    prohibitedActivities8:
      "如果您的預訂或賬戶存在欺詐、濫用或可疑活動跡象，Trip 可以取消與您的姓名、電子郵件地址或賬戶相關的任何旅遊或服務預訂，並關閉任何相關的 Trip 賬戶。如果您已進行任何欺詐活動，Trip 保留采取任何必要法律行動的權利，並且您可能需要因此向 Trip 賠償金錢損失，包括訴訟費用和損害賠償。如對預訂取消、賬戶凍結或關閉存在異議，請聯系 Trip 客服部。",
    privacyPolicyDetail:
      "Trip 主張保護您的隱私。請點擊此處查看我們當前的隱私政策，了解我們的常規做法。如上所述，該政策還規定了您對本網站的使用，並通過引用隱私政策而納入本協議:",
    supplierRulesAndRestrictions: "供應商的規則和限制",
    supplierRulesAndRestrictions1:
      "附加條款和條件將適用於您選擇的旅遊相關商品和服務的預訂與購買。請仔細閱讀這些附加條款條件。尤其是，如果您已購買了飛機票，請務必閱讀旅行供應商在供應商網站發布的所有載運條款與條件。對於您選擇與之進行交易的任何供應商，您同意遵守其購買條款與條件，包括但不限於支付全部應付金額，遵守供應商的費用、產品或服務的可用性方面的規定與限制。飛機票價僅在購買完成和機票發放後才有保障。航空公司和其他旅遊供應商可以變更價格，恕不另行通知。如果我們沒有按時收到您的全額付款，我們有權取消您的預訂。",
    supplierRulesAndRestrictions2:
      "Trip 可能會向您提供預訂兩張單程票組合，而非往返機票的機會。兩張單程機票的價格通常更便宜，而且航班的選擇範圍更廣，您可以選擇相同的航空公司，也可選擇不同的航空公司。與往返機票不同，每張單程機票都會受到所屬航空公司的規定、限制和費用的影響。如果其中一個航班受到航空公司變更的影響（如航班取消或改期），客戶就必須改簽另一個航班，客戶須負擔改簽未受影響航班所產生的所有費用。",
    supplierRulesAndRestrictions3:
      "對於某些低成本航空公司，您的航班票價已從其它貨幣換算為您的本地貨幣，便於您估計購票金額。因此，當您預訂時，由於匯率波動航空公司從您的信用卡上所扣取的金額可能略有不同。您的對賬單可能還包括您的發卡機構處理交易時產生的費用，以及進行國際購物時產生的任何適當稅款。",
    supplierRulesAndRestrictions4:
      "聯邦法律禁止在通過行李中夾帶或是隨身的方式攜帶任何危險品登機。違反規定者可處以五年監禁和 25 萬美元或以上的罰款 (49 U.S.C. 5124)。危險品包括爆炸物、壓縮氣體、可燃性液體和固體、氧化劑、毒物、腐蝕性和放射性物質。示例：油漆、打火機液、煙花、催淚瓦斯、氧氣瓶和放射性藥品。特殊例外情況有，行李中的少量（總計最多 70 盎司）藥品和盥洗用品，以及隨身攜帶的某些煙草用品。",
    supplierRulesAndRestrictions5:
      "您確認，一些提供某些服務和/或活動的第三方供應商可能要求您先簽署免責聲明書後，再參加他們提供的服務和/或活動。您明白，任何違反上述供應商規則和限制的行為均可能導致您的預訂被取消、導致您被拒絕訪問相應的旅遊產品或服務、導致您喪失所支付的預訂費用、和/或導致我們將該違反行為對我們造成的任何費用記入您賬戶。",
    bankAndCreditCardFees: "銀行和信用卡費用",
    bankAndCreditCardFees1:
      "當旅行供應商處理您的付款時，您的付款將在供應商總部所在的國家/地區處理。",
    bankAndCreditCardFees2:
      "Trip 或旅行供應商可能會驗證：(i) 付款卡的有效性（通過收取一項可在數日內進行退款的或可由旅行供應商從最終付款中扣除的票面值），及 (ii) 付款卡的資金可用性（由您的信用卡發卡行確認）。",
    bankAndCreditCardFees3:
      "一些銀行和信用卡公司會收取國際或跨國交易費用。例如，如果您使用美國銀行發行的卡預訂非美國商家的產品/服務，您的銀行可能會向您收取跨境或國際交易費。而且，您的銀行或信用卡公司可能將您的國際旅行預訂視為國際交易，因為我們可能會將您的卡片詳細信息提供給國際旅行供應商作付款之用。此外，一些銀行和信用卡公司會收取外幣兌換費。例如，如果您在預訂時使用的貨幣與信用卡所用的貨幣不同，您的信用卡公司可能會將預訂金額兌換為您的信用卡所用的貨幣單位，並收取外幣兌換費。貨幣匯率和外幣交易費完全由您的銀行在處理交易的當天決定。如果您對此類費用或預訂所適用的匯率有任何疑問，請聯系您的銀行。",
    currencyConverter: "貨幣換算器",
    currencyConverter1:
      "如果本網站提供貨幣換算器，則下述條款和條件適用：匯率基於各種公開來源提供的數據，僅供參考。我們沒有驗證匯率的準確性，實際匯率可能有所變化。貨幣報價並非每天更新。請檢查貨幣轉換器功能上的日期，了解最新更新之日的匯率。此應用程序提供的信息被認為是準確的，但 Trip 公司、Trip 合作夥伴和/或我們各自的供應商不擔保或保證其準確性。在將此信息用於金融目的時，我們建議您咨詢合格的專業人員，查證匯率的準確性。我們不授權將此信息用於您個人使用之外的任何目的，明確禁止您轉售、再分發此信息和將其用於商業目的。",
    InternationalTourism: "國際旅遊",
    InternationalTourism1:
      "您負責確保您符合外國人入境要求，確保您的旅遊證件，如護照和簽證（過境、商務、旅遊及其他）齊全並滿足任何其他外國人入境要求。Trip 不具備有關外國人入境要求或旅遊證件的專業知識。在預訂國際旅行目的地之前，我們強烈建議客戶查看旅行禁令、警告、通告及相關政府發布的公告。",
    InternationalTourism2:
      "護照和簽證：您必須咨詢相關大使館或領事館了解相關信息。要求可能會有變化，在預訂和動身之前，您應適時了解最新的信息。如果因您沒有攜帶任何航空公司、管理機構或國家（包括您只是過境的國家）要求的正確的護照、簽證或其他旅遊證件而被拒絕登機或進入任何國家，我們不承擔任何責任。這包括飛機造成的全部停留，即使您沒有離開飛機或機場。",
    InternationalTourism3:
      "健康：推薦的旅遊接種可能發生變化，您應在動身之前咨詢您的醫生，了解當前推薦的接種疫苗。您應負責確保您滿足所有健康入境要求，進行推薦的接種，攜帶所有推薦的藥物，並遵守與您的旅途相關的所有醫囑。",
    InternationalTourism4:
      "滅蟲：盡管不常發生，但大多數國家/地區保留在明顯對公共衛生、農業或環境構成威脅時，對飛機進行滅蟲的權力。國際衛生組織和國際民航組織已批準下述滅蟲程序：(1) 乘客在飛機上時在客艙內噴灑霧化殺蟲劑，或者 (2) 乘客不在飛機上時用殘留殺蟲劑處理航空器內表面。",
    InternationalTourism5:
      "Trip 提供特定國際目的地的旅遊產品預訂，並不代表其聲明或保證前往此地區旅行是可取的或沒有風險，Trip 也不承擔到此地區旅遊所可能造成的傷害或損失的責任。",
    disclaimerDetail: "免責聲明",
    disclaimerDetail1:
      "此網站上公布的信息、軟件、產品及服務可能存在誤差或錯誤，包括價格錯誤。特別要指出的是，Trip 公司以及 Trip 合作夥伴不保證本網站上顯示的航班及其他旅行產品和服務的信息和描述（包括但不限於定價、照片、一般產品描述等）的正確性，也不對與此類信息和描述相關的任何錯誤或其他誤差承擔任何責任。此外，Trip 明確保留糾正我們網站上的任何定價錯誤和/或按照錯誤價格進行的預訂的權利。",
    disclaimerDetail2:
      "Trip 公司、Trip 合作夥伴及其各自的供應商不對本網站上所包含的信息、軟件、產品和服務針對任何目的的適用性做任何聲明；在本網站上包含或提供任何產品或服務不構成 Trip 公司或 Trip 合作夥伴對此類產品或服務作出的任何認可或推薦。所有此類信息、軟件、產品及服務均“按原樣”提供，不含有任何保證。Trip 公司、Trip 合作夥伴及其各自的供應商拒絕承認任何擔保及條件，即本網站、網站服務器或 Trip 公司、Trip 合作夥伴和/或其各自的供應商所發送的任何電子郵件不含病毒或其他有害組件。Trip 公司、Trip 合作夥伴及其各自的供應商在此拒絕承認與此信息、軟件、產品和服務有關的所有擔保及條件，包括所有對適銷性、特定用途適用性、產權和非侵權性的默示擔保及條件。",
    disclaimerDetail3:
      "在本網站上提供旅行服務或其他服務的承運商及其他供應商為獨立的立約方，並非 Trip 公司或 Trip 合作夥伴的代理或員工。Trip 公司和 Trip 合作夥伴不對任何此類供應商的行為、錯誤、失職、聲明、擔保、違規或疏忽負責，也不對由此造成的任何人身傷害、死亡、財產損害或由此產生的其他損害或費用負責。如果發生延遲、取消、過量預訂、罷工、不可抗力或其他超出直接控制範圍之事由，Trip 公司和 Trip 合作夥伴不承擔任何責任且不予退款，並且不對任何額外費用、失職、延遲、重新安排路線或任何政府或機構的行為負責。",
    disclaimerDetail4:
      "對於您訪問、展示或使用本網站引起或與此相關，或與延遲或無法訪問、展示或使用本網站相關的任何直接、間接、懲罰性、附帶性、特殊或後果性損害賠償（包括但不限於您對本網站上的觀點的依賴；任何計算機病毒、信息、軟件、鏈接的網站、通過本網站獲取的產品和服務；或由訪問、展示或使用本網站引起），Trip 公司、Trip 合作夥伴和/或其各自的供應商在任何情況下均不承擔責任，不論是基於過失論、合約、侵權、嚴格責任、消費者保護法或其他，且即使在 Trip 公司、Trip 合作夥伴和/或其各自的供應商已被告知該類損害賠償的可能性的情況下也是如此。",
    disclaimerDetail5:
      "盡管有以上規定，但如果 Trip 公司、Trip 合作夥伴或其各自的供應商被認定對由任何上述情形引起或與之相關的任何損失或損害負有責任，則 Trip 公司、Trip 合作夥伴和/或其各自的供應商的責任在任何情況下總計不得高於以下費用中的較高者：(a) 您為本網站上的此類交易向 Trip 支付的服務費用，或 (b) 一百美元 (US$100.00) 或以當地貨幣計算的等值金額。",
    disclaimerDetail6:
      "責任限制反映了雙方之間的風險分配。如果本使用條款所述的任何有限補救未能達到其基本目的，本節所述限制將繼續有效並適用。本使用條款規定的責任限制有利於 Trip 公司、Trip 合作夥伴和/或其各自的供應商。",
    theCompensation: "賠償",
    theCompensation1:
      "對於第三方因下列原因向 Trip 公司、Trip 合作夥伴和/或其各自的供應商及其任何高管、總監、員工和代理提出的任何索賠、訴訟、要求、追償金、損失、損害賠償金、罰款、罰金或其他任何類型或性質的費用或開支，包括但不限於合理的法律費用和會計費用，您同意為其進行辯護並進行相應賠償：",
    theCompensation2: "您違反本使用條款或使用條款引用的文檔；",
    theCompensation3: "您違反任何法律規定或影響第三方權利；",
    theCompensation4: "您對此網站的使用。",
    thirdPartySiteLinks: "第三方網站鏈接",
    thirdPartySiteLinksDetail:
      "本網站可能含有 Trip 之外的第三方運營的網站超鏈接。該等超鏈接僅供您參考。我們對此類網站沒有控制權，不對此類網站的內容或隱私權或其他做法負責。此外，您應采取預防措施，確保您選擇的任何鏈接或您下載的軟件（不論從此網站還是其他網站）不含病毒、蠕蟲、特洛伊木馬病毒、缺陷及其他具有破壞性的項目。我們包含對此類網站的超鏈接不意味著我們認可此類網站的內容，或與此類網站的運營商有任何關系。",
    softwareProvidedOnThisSite: "此網站提供的軟件",
    softwareProvidedOnThisSite1:
      "可以從本網站或通過包括 Trip 移動應用（以下簡稱“移動應用”）在內的移動應用商店下載的任何軟件（以下簡稱“軟件”），均為 Trip 公司和/或我們各自供應商的受版權保護的產品。您對此類軟件的使用受最終用戶許可協議（如果有）的條款約束，該協議與軟件同時提供或包含在軟件中（以下簡稱“許可協議”）。您只有首先同意附於軟件或軟件所含的許可協議的條款，才能安裝或使用該軟件。對於本網站上可以下載的沒有隨附許可協議的任何軟件，我們特此授予您（用戶）有限的、個人的、非獨占且不可轉讓的許可，以根據本使用條款下載、安裝和使用軟件和/或移動應用，以查看或以其他方式使用本網站和/或訪問移動應用中可用的內容和信息（包括但不限於旅遊服務的價格與可用性），但不得用於其他目的。",
    softwareProvidedOnThisSite2:
      "請註意，所有軟件（包括但不限於本網站上包含的所有 HTML 代碼和 Active X 控件）均為 Trip 公司、Trip 合作夥伴和/或我們各自的供應商所有，受版權法和國際公約的相關規定的保護。軟件的任何復制或再分發均受到明令禁止，且可能導致嚴重的民事和刑事處罰。違者將受到最嚴厲的處罰。",
    softwareProvidedOnThisSite3:
      "明確禁止將軟件復制或再分發到任何其他服務器或地點進行進一步復制或再分發，本條款不限制上述條文。如果需要授權軟件，將僅根據許可協議的條款進行授權。",
    softwareProvidedOnThisSite4:
      "您的移動設備必須連接至互聯網，以使移動應用正常運行。您應負責進行所有必要的安排，以使您的移動設備連接至互聯網，您還應承擔服務提供商向您收取的移動應用收發數據所產生的全部費用（包括但不限於數據漫遊費用）。正如我們的隱私政策所述，作為正常運行的一部分，移動應用將會自動傳送少量的數據，包括您使用移動應用的方式、您訪問的內容、應用程序在使用時遇到的技術錯誤或問題。使用移動應用，即表明您確認並同意對此類信息的自動收集。",
    commentsPhotosAndOtherSubmittedContent: "点评、评论、照片和其他提交内容",
    commentsPhotosAndOtherSubmittedContent1:
      "我們歡迎您提出反饋意見和建議。請註意，通過電子郵件、在本網站上發布內容或以其他方式向本網站提交內容（包括任何點評、照片、視頻、問題、評論、建議、想法或類似內容，統稱“提交內容”），即表明您向 Trip 以及我們通過其提供服務的關聯、聯合品牌和/或鏈接的網站合作夥伴（統稱“Trip 合作夥伴”）授予非獨家、免版稅、永久、可轉讓、不可撤銷且完全可轉讓許可的權限進行以下行為：(a) 在全球範圍內現在已知或以後出現的任何媒體上使用、復制、修改、改編、翻譯、分發、發布、據此創作衍生內容、公開展示及演示此類提交內容；以及 (b) 使用您在此類提交內容中提交的姓名。您確認，Trip 公司可以自行選擇提供您的點評或評論的歸屬信息（如在您提交的評論中列出您姓名和家鄉），該類提交內容可能會與我們的供應商合作夥伴分享。您進一步授權 Trip 公司，可以對違反這些使用條款而侵犯您或 Trip 公司在該提交內容中的權利的個人或實體依法進行追究。您確認並同意，意見不具有機密性和專屬性。您明確放棄您所提交內容的任何“著作人身權”（包括歸屬權或完整權），並同意您對我們、Trip 合作夥伴或者我們的任何合作夥伴或被許可人發布、使用、修改、刪除或利用您的提交內容無任何異議。我們對您發布或提交的任何意見概不負責。對於您的評論，我們無發布的義務；我們可以全權決定要在網站發布哪些評論。如果您不同意這些使用條款，則請勿向我們提供任何意見。",
    commentsPhotosAndOtherSubmittedContent2:
      "您對您的意見內容（特別是，包括但不限於發布到此網站的評論）負有完全責任。您不得向/從本網站發布或散播以下內容：(i) 任何不合法、恐嚇、誹謗、中傷、淫穢、色情信息，或者侵犯公開權和/或隱私權或違反任何法律的其他材料或內容；(ii) 任何商業材料或內容（包括但不限於籌集資金、任何商品或服務的廣告或推廣）；以及 (iii) 侵犯、濫用或違反任何第三方的任何版權、商標、專利權或其他專有權利的任何材料或內容。對於違反上述限制所造成的損害，或您在此網站上發布的內容所造成的其他任何傷害，您應獨自承擔全部責任。您確認，Trip 可以行使針對您提交的任何內容的權利（如使用、出版、刪除），恕不另行通知。",
    commentsPhotosAndOtherSubmittedContent3:
      "對於第三方針對本網站內容（包括任何提交內容）侵犯上述第三方的版權而提出索賠，Trip 對該等第三方權利的主張政策見下述“版權侵犯索賠”。",
    commentsPhotosAndOtherSubmittedContent4:
      "本網站配有 Google® 翻譯工具，使您能夠翻譯用戶生成評論等內容。Google® 翻譯工具通過自動程序翻譯文本，這可能使文本不準確。使用 Google® 翻譯工具帶來的風險完全由您自行承擔。Trip 對 Google® 翻譯提供的翻譯準確性或完整性不做出保證、承諾、確保或保障。",
    copyrightAndTrademarkDeclaration: "版權和商標聲明",
    copyrightAndTrademarkDeclaration1:
      "此網站上全部內容均歸 香港五洲國際旅遊有限公司版權所有。保留所有權利。Trip 徽標均是香港五洲國際旅遊有限公司在其他國家的註冊商標或商標。本使用條款中提及的其他徽標和產品及公司名稱可能是其各自所有者的商標。香港五洲國際旅遊有限公司對網站上 Trip 之外各方運營的內容不承擔責任。",
    copyrightAndTrademarkDeclaration2:
      "如果您註意到存在對我們品牌的侵權行為，請通過郵件告知我們reynold.zhang@5u6o7se0.dingmail.work 此電子郵件地址只負責處理品牌侵權的相關信息。",
    accountTermination: "賬戶終止",
    accountTerminationDetail:
      "根據《千禧年數字版權法案》(“DMCA”)和其他適用法律，Trip 已經實施了一項賬戶終止政策，可在相應情況下由Trip 自行決定終止被認為重復侵權的訂閱人或賬戶持有人的訪問權限。對於侵犯他人任何知識產權的用戶，不論是否為多次侵權，Trip 均可以自行限制該用戶對網站的訪問和/或終止其賬戶。如果您認為某賬戶持有人或訂戶為屢次侵權人，請在提交通知時提供充分的信息，以便我們查證該賬戶持有人或訂戶是否為屢次侵權人。",
    noticeOfInfringement: "侵權材料通知",
    noticeOfInfringementDetail:
      "如果您有充分的理由認為我們托管的材料侵犯了您的版權，您（或您的代理人）可寄給我們一則書面通知，通知中包含以下信息。請註意，如果您的投訴填寫不當或不完整，我們將不會處理您的投訴。您在通知中有關正在侵權的內容或活動的任何虛假陳述均有可能使您面臨損害賠償。",
    noticeOfInfringement1: "1.明確指出您聲稱受到侵權的受版權法保護的作品。",
    noticeOfInfringement2:
      "2.明確指出本網站上您聲稱受到侵權的材料，例如指向侵權材料的鏈接。",
    noticeOfInfringement3: "3.您的姓名、地址、電子郵件地址和電話號碼。",
    noticeOfInfringement4:
      "4.聲明“您有充分的理由認為，聲稱侵犯版權的材料未獲得版權所有人、代理人或法律的授權。",
    noticeOfInfringement5:
      "5.聲明“通知中的信息準確無誤，並且投訴方已獲得授權，可代表宣稱受到侵犯的專屬權利的所有人 - 如有不實，當受偽證罪之處罰。",
    noticeOfInfringement6:
      "6.通知必須由已獲授權的人簽署，此人有權代表宣稱受到侵犯的專屬權利的所有人。",
    noticeOfInfringement7:
      "您可將您的通知發送到我們的電子郵件地址：reynold.zhang@5u6o7se0.dingmail.work，或發送傳真至 （852）3193-9788，或通過下述聯系信息將通知發送給我們。",
    objectionToInform: "異議通知",
    objectionToInformDetail:
      "如果您發布的材料已下線，我您可通過傳真或普通郵件向我們發送一份異議通知，通知須包含下列事項。在發出異議通知之前，您可以尋求法律咨詢。請包含下述詳細內容：",
    objectionToInform1:
      "1.說明已刪除或禁止訪問的具體內容以及該內容之前在 Trip 網站出現的位置。如有可能，請提供 URL 地址。",
    objectionToInform2: "2.您的姓名、通信地址、電話號碼和電子郵件地址。",
    objectionToInform3:
      "3.一份聲明，表明您同意您的地址所處司法管轄區的聯邦地區法院的管轄權，或者如果您的地址不在美國境內，您同意 Trip 所處的任何司法管轄區的聯邦地區法院的管轄權；您還應聲明您會接受舉報您的內容的一方或該方代理人送達的法律程序文件。",
    objectionToInform4:
      '3.下述聲明：“我發誓，根據偽證處罰條款，我有充分的理由相信以上所確定內容因錯誤或錯判而被刪除或禁用。"',
    objectionToInform5: "在文件上簽字。",
    objectionToInform6: "將書面通知發送至下列地址：",
    objectionToInform7:
      "香港五洲國際旅遊有限公司.\n" + "九龍旺角彌敦道739號金輪大廈15樓G室",
    objectionToInform8:
      "您也可以發送傳真至：（852）3193-9788，如有任何針對 Trip 的 DMCA 程序相關的其他疑問，請撥打電話 （852）3193-9788 聯系我們。",
    thePatentStatement: "專利聲明",
    thePatentStatementDetail:
      "香港五洲國際旅遊有限公司擁有的一個或多個專利可能適用於本網站和適用於可以通過本網站訪問的功能和服務。本網站的部分頁面是在一個或多個專利的許可下運營。其他專利正在申請中。",
    mapTerms: "地圖條款",
    mapTermsDetail:
      "您在使用本網站的地圖功能時，須遵守 Microsoft 使用條款、Microsoft 隱私聲明、Google 使用條款和 Google 隱私聲明。Microsoft 和 Google 有權隨時自行變更他們的使用條款和隱私聲明。請點擊此處了解更多信息：",
    mapTerms1: "http://privacy.microsoft.com/en-us/default.mspx",
    mapTerms2: "http://www.microsoft.com/maps/assets/docs/terms.aspx",
    mapTerms3: "http://www.google.com/privacy/privacy-policy.html",
    mapTerms4:
      "http://www.google.com/enterprise/earthmaps/legal/us/maps_AUP.html",
    mapTerms5: "http://www.maps.google.com/help/legalnotices_maps.html",
    mapTerms6: "http://maps.google.com/help/terms_maps.html",
    mapTerms7:
      "地圖中所用的 OpenStreetMap 地理數據由 (c) OpenStreetMap 提供，根據開放數據庫許可 開放數據庫許可 (ODbL) 使用",
    generalPrinciples: "一般原則",
    generalPrinciples1:
      "本使用條款受美國聯邦仲裁法案和聯邦仲裁法律的約束，且對於美國居民進行的預訂，本使用條款還受其帳單地址所在州的法律之約束，無論是否存在法律沖突原則。在任何不承認本協議所有條款（包括但不限於本段落）均有效的司法管轄權地使用本網站均被視作未經授權使用。",
    generalPrinciples2:
      "您同意簽署本協議或使用本網站不代表您和 Trip 公司之間存在合資、合作或雇傭關系 ",
    generalPrinciples3:
      "我們對該協議的履行遵從現有法律及法務流程。對於您對本網站的使用或您向我們提供或我們收集的關於該使用的信息，該協議不限制我們使用這些信息以遵守執法部門或其他政府或法律請求或要求。",
    generalPrinciples4:
      "若該協議的任一部分被確認為無效、違法或不可執行，其余條款的有效性、合法性和可執行性將不受到任何形式的影響或損害。我們在任何時間對該協議中任一條款的執行失敗或延遲執行不代表我們放棄在未來執行該條款或其他任何條款的權利。",
    generalPrinciples5:
      "本協議（以及本協議所引用的任何其他條款和條件）構成您與 Trip 之間就本網站、我們的服務以及您與我們之間的交易和關系而達成的完整協議，並取代我們雙方所有先前或當前的電子、口頭或書面通信和建議。協議的打印版和任何電子形式的通知在基於協議或與協議有關的司法或行政訴訟中應受到同樣範圍的采納，並應和其他最初以印刷形式產生並維護的業務文件及記錄一樣受相同條件的約束。",
    generalPrinciples6:
      "此網站提及的虛構公司名、產品名、人名、人物和/或數據無意描述任何真實的個人、公司、產品或事件。",
    generalPrinciples7: "我們保留本協議沒有明確授權的所有權利。",

    ///////////
    adultsAndChildrenCannotExceed9: "總人數不超過9人.",
    oneAdultsOnlyOnebaby: "每位成人僅可攜帶 1 名嬰兒 (0-2 歲)",
    pay: "付款",
    onward: "去程",
    return1: "返程",
    enterPhoneNumber: "請輸入手機號碼",
    enterYourMailAddress: "請輸入電子郵箱",
    payImmediatelyAfterPurchase: "購買成功請立即支付",
    cabinSoldOut: "艙位已售完",
    numberOfCabinIsInsufficient: "艙位數不足",
    systemError: "系統錯誤",
    failureOfReservation:
      "我們檢測到您可能在其它平台/系統使用同樣客戶信息預定相同的航班艙位信息，導致訂位失敗！",
    toA: "至",
    priceCheckFailed: "很抱歉，您選擇的價格艙位已銷售完，請重新查詢!",
    recheckTheFlight: "您需要返回機票查詢頁面，重新查詢班機 ",
    mailAddressOrPhoneNumberError: "郵箱或手機錯誤",
    loggingIn: "登入中",
    passwordPassed: "密碼通過",
    loginSuccess: "登入成功",
    loginAgain: "請重新登入",
    enterTheCorrectEmailFormat: "請輸入正確的郵箱格式",
    refundOrChangeRules: "退改規則",
    refundRules: "退票規則",
    changeRules: "改簽規則",

    nodataMessage1: "我們蒐索了400多家航空公司的資訊，未找到任何在",
    nodataMessage2: "從",
    nodataMessage3: "的去程班機",
    nodataMessage4: "下麵的小提示可以幫您找到合適的班機：",
    nodataMessage5: "將到達或出發目的地改為附近的機場。",
    nodataMessage6: "嘗試將到達或出發日期提前或者延后一天。",
    nodataMessage7: "的返程班機。",

    nodataConditionsMessage1: "您選擇的篩選條件過多，未找到完全符合的班機",
    nodataConditionsMessage2: "可以减少篩選條件得以找到較為符合您的班機。",
    nodataConditionsMessage3: "選擇您搜索結果的其它班機。",

    refreshSearch:
      "班機價格經常隨供需變化發生波動。我們希望確保您看到的是最好的價格，而且是有保證的價格。",
    refreshSearchTitle: "請刷新搜索，以了解最新價格。",
    okrefresh: "重新搜索",
    tips: "提示",
    segment: "航段",
    priceOfYourScheduledFlightHasFluctuated: "您所預定的班機價格發生波動 ",
    afterChange: "變更後",
    travelPrice: "行程總價",
    returnBack: "返回",
    loginSuccessLoading: "登入成功，加載中…",
    onwardSegment: "去程航段",
    returnSegment: "返程航段",
    accountOrPasswordError: "用戶名或密碼錯誤",
    pleaseEnterTheNameOfThePassport: "請輸入護照上的名字",
    ticketsZ: "張票",
    loadingmessage: "正在處理您的請求...",
    pleaseEnter: "請輸入",
    isloginout: "是否確定註銷登錄？選擇確定將為您跳轉至首頁。",
    agreeoneworldtrip: "請同意遵守規則",

    //客服中心
    airlineReservationConfirmation: "查看您的機票預訂確認",
    operationSteps: "操作步驟",
    operationSteps1: "前往我的行程查看、通過電子郵件發送或打印您的行程或收據。",
    operationSteps2: "查看確認郵件。",
    operationSteps3: "如果您預訂時未登錄，請前往查找行程。",
    operationSteps4: "如果您在我的行程中沒有看到您的行程，可能是因為：",
    operationSteps5: "您預訂時並未登錄。",
    operationSteps6:
      "您預訂時使用了Trip 積分。這些訂單最多可能需要 24 小時才會在我的行程中顯示出來。",
    friendshipHints: "友情提示",
    friendshipHints1: "有關行李的信息，請參閱行李費用和限額。",
    friendshipHints2: "要提出特殊要求，比如餐點或輪椅，請直接聯系航空公司。",
    friendshipHints3:
      "如果您通過航空公司直接進行變更，這些變更不會出現在您的行程中。",
    anyOtherAssistance: "需要其他協助？",
    anyOtherAssistanceDetail:
      "如果您尚未收到您的確認郵件或需要查看預訂的幫助，請聯系我們 。",
    luggage: "行李",
    checkItinerary: "檢查行程單",
    howToOperateConcretely: "如何具體運作",
    howToOperateConcretelyDetail:
      "行李費和限重取決於航空公司和預訂的機票類型。",
    checkRelativeBaggageTicket:
      "要查看特定機票的相關行李信息，請進行以下操作：",
    checkRelativeBaggageTicket1: "登錄賬戶，查看訂單。",
    checkRelativeBaggageTicket2: "選擇您的行程單。",
    moreInformationContactYourAirlineDirectly:
      "如需以下方面的更多信息，請直接聯系您的航空公司：",
    moreInformationContactYourAirlineDirectly1: "托運行李所含物品",
    moreInformationContactYourAirlineDirectly2: "隨身行李限重",
    moreInformationContactYourAirlineDirectly3: "附加行李費",
    moreInformationContactYourAirlineDirectly4: "違禁物品",
    moreInformationContactYourAirlineDirectly5: "超大行李政策",
    moreInformationContactYourAirlineDirectly6: "運動裝備",
    moreInformationContactYourAirlineDirectly7: "無障礙設施的提供和使用",
    aRoundTripContaining2OneWayTickets: "包含 2 張單程票的往返機票",
    aRoundTripContaining2OneWayTicketsDetail:
      "部分往返機票包含 2 張單程票，每張單程票要求遵循各自的規定和限制。如果這種組合機票的價格比常規往返票價更具競爭力，我們將提供組合機票供預訂，並為您提供更合適的選擇。",
    book: "預訂",
    book1: "這種往返機票只能在線預訂。",
    book2:
      "行李政策因航空公司而異。有關詳情，請參閱每張機票對應的行李費用和限額以及航空公司費用。",
    changeAndRefundDetail1:
      "每張單程票只能單獨改簽或退票。改簽或退票往返機票中的一張機票不會自動更新或影響另外一張機票。",
    changeAndRefundDetail2:
      "您的一張單程票發生由航空公司自主的時間表變更時，另外一張單程票不會自動更新。要變更另一張機票，則可能需要支付變更手續費。歡迎聯系我們以獲得幫助。",
    changeAndRefundDetail3:
      "如果您的其中一張機票為低成本航空公司機票，您必須直接聯系該航空公司進行變更。然後，請聯系我們變更旅行中預訂的第二張機票（如果需要的話）。",
    changeAndRefundDetail4:
      "如果兩張單程票均為低成本航空公司機票，請直接聯系相關的各家航空公司來變更或取消機票。",
    changeAndRefundDetail5:
      "變更或取消機票前，請查閱行程，了解航空公司收取的變更和取消費用。",
    changeFlightSchedule: "改簽機票",
    lowCostAirlines: "低成本航空公司",
    lowCostAirlines1: "低成本航空公司，要求您直接聯系航空公司以變更您的航班。",
    lowCostAirlines2: "含 2 張單程票的往返機票",
    lowCostAirlines3:
      "如果您的往返機票包含 2 張單程機票，請參閱含 2 張單程票的往返機票。",
    flightChangeFee: "航班改簽費用",
    flightChangeFee1:
      "變更總費用取決於您的機票價格及航空公司可能收取的任何費用。您的改簽費用可能包括：",
    flightChangeFee2: "每張機票的航空公司航班變更費用。",
    flightChangeFee3: "機票差價（如果改簽後的航班價格超過原航班價格）。",
    toEstimateTheCostOfChangingFlights: "如要估算航班改簽費用",
    toEstimateTheCostOfChangingFlights1: "請登錄賬戶，查看訂單。",
    toEstimateTheCostOfChangingFlights2: "在我的行程中，選擇要改簽的行程單。",
    changingHelp: "如果您在改簽機票方面需要協助，請聯系我們。",
    refundATicket: "退票",
    lowCostAirlinesRequireDirectlyCancelFlight:
      "低成本航空公司，要求您直接聯系航空公司以取消您的班機。",
    contactUsAssistanceCancelingAirlineTickets:
      "如果您在取消機票方面需要協助，請聯繫我們。",
    refundATicketDetail:
      "取消航班之前，請查看您的行程中關於航班條款與規定部分，了解可能產生的航班取消費用。可能產生的費用一律由航空公司（而非我們）要求收取。",
    cancelYourAirlineTicketOnline: "在線取消您的機票預訂",
    cancelYourAirlineTicketOnline1: "請登錄賬戶，查看訂單。",
    cancelYourAirlineTicketOnline2: "在我的行程中，選擇要改簽的行程單。",
    cancelYourAirlineTicketOnline3:
      "要取消此類往返機票，您必須分別取消每張單程票。如果其中一張機票為低成本航空公司機票，您必須直接聯系該航空公司進行變更。如需了解更多信息，請參閱含 2 張單程票的往返機票。",
    refundHints1:
      "如果您未搭乘去程航班，航空公司將自動取消您的返程航班，除非您預訂的往返機票含 2 張單程票。",
    refundHints2: "如果航空公司取消了您的航班，請參閱航空公司主動變更行程。",
    refundHints3: "有關航班保險的信息，請參閱航班保險規則。",
    refundHints4: "有關退款信息，請參閱航司退款規則。",
    airlinesIndependentlyChangeSchedules: "航空公司自主對時間表做出變更",
    airlinesIndependentlyChangeSchedulesDetail:
      "有時候基於各種原因，如航班號、飛行路線或起飛時間的調整，航空公司會自主對時間表做出變更。如果航空公司自主對您的航班行程做出變更，則不會向您收取變更費或機票差價。",
    lowCostAirlinesIndependently1:
      "如果您通過低成本航空公司預訂機票，請直接聯系航空公司，處理任何時間表變更相關的問題。我們的客服無法對低成本航空公司的預訂做出任何變更。",
    lowCostAirlinesIndependently2:
      "如果您的行程中僅有一張機票屬於低成本航空公司，並且是該航空公司自主對該航班做出變更，請按以下步驟操作：",
    lowCostAirlinesIndependently3: "聯系低成本航空公司，對您的預訂做出變更。",
    lowCostAirlinesIndependently4:
      "一旦您與該低成本航空公司確認變更後，如果還需要對您的其余行程做出任何額外變更，請聯系我們。",
    omniServiceAirlines: "全方位服務航空公司",
    omniServiceAirlines1:
      "如有時間表變更，我們將與您的航空公司緊密協作，以提供與您的原始航班相當的新航班選項。我們確定了相當的航班選項後，就會通過電子郵件或電話聯系您以說明詳情。",
    omniServiceAirlines2:
      "對於某些時間表變更，您不必做任何事。但在另一些情況下，您可能需要采取相應行動，取決於我們發送給您的航空公司時間表變更通知。",
    changeNotificationEmail: "當您收到變更通知郵件",
    changeNotificationEmail1:
      "查看時間表變更的詳細信息，並遵照郵件中的說明操作。",
    changeNotificationEmail2:
      "根據時間表變更的類型，您可能需要或無需聯系我們來確認變更。",
    changeNotificationEmail3:
      "時間表變更完成後，我們將發送包含更新行程的確認郵件給您。",
    changeNoticePhoneNumber: "當您接到變更通知電話",
    changeNoticePhoneNumber1:
      "有時候，除了發送有關變更的郵件給您，我們還會嘗試通過電話聯系您。",
    changeNoticePhoneNumber2:
      "當我們與您確認了航班變更並且獲得航空公司批準之後，我們將會發送包含更新行程的確認郵件給您。",
    notificationFriendshipHints1:
      "如果您最初購買機票時付費訂了座位或購買了其他升級服務，請直接聯系相關航空公司，確保這些服務會轉移到您的新機票上。",
    notificationFriendshipHints2:
      "航空公司自主的時間表變更完成後，未來若您需要對該機票做出任何變更，將需遵守原始機票的規定和限制。請查閱變更機票了解進一步信息。",
    welcomeContactUsForHelp: "歡迎聯系我們以獲得幫助。",
    ticketTransfer: "機票轉讓",
    ticketTransfer1: "您不能將機票轉讓給其他旅客。",
    ticketTransfer2: "如果您需要取消或重新預訂機票，請註意：",
    ticketTransfer3: "大多數航空公司的機票都是不可退款的。",
    ticketTransfer4:
      "大多數航空公司都收取機票變更或取消費用。請查看您的行程單，了解詳細信息。",
    ticketTransfer5:
      "如果機票上的姓名與政府簽發的帶本人照片的身份證件不符，請及早抵達機場並在航空公司櫃臺處出示姓名變更證明（例如結婚證或其他法律文件）。",
    mistakenMachine: "誤機",
    mistakenMachineOperate: "如何操作",
    mistakenMachineOperate1:
      "如果您錯過了航班，請直接聯系航空公司以獲得協助。某些航空公司可能會安排您搭乘下一趟合適的航班。",
    mistakenMachineOperate2:
      "因錯過航班而申請的退款請求，需按照航空公司規定的手續費與限制條件進行處理。",
    mistakenMachineFriendshipHint:
      "如果航空公司變更或取消了您的航班，請參閱航空公司主動變更行程。",
    needOtherHelpContactUs: "如需其他幫助，請聯系我們。",
    manageLowCostAirlineReservations: "管理低成本航空公司預訂",
    manageLowCostAirlineReservations1:
      "如果您預訂了低成本航空公司的機票，請直接聯系航空公司，對預訂進行變更、取消或管理。我們不能直接訪問低成本航空公司的預訂系統。",
    manageLowCostAirlineReservations2:
      "要管理此類預訂，建議您從相應航空公司的網站入手。很多低成本航空公司提供各種自助服務功能，例如：",
    manageLowCostAirlineReservations3: "在線辦理登機手續",
    manageLowCostAirlineReservations4: "選擇座位",
    manageLowCostAirlineReservations5: "預訂行李服務",
    payment: "付款",
    ticketPaymentMethod: "機票預訂付款方式",
    onlinePaymentDetail:
      "您必須在預訂機票時全額付款。您可以使用借記卡、信用卡、微信或支付寶在線付款。Trip 不接受訂金或分期付款的方式。",
    onlinePaymentHints1: "不可分用 2 張或更多張信用卡進行付款。",
    onlinePaymentHints2:
      "在通過借記卡或信用卡進行大額付款之前，請聯系相關銀行或信用卡公司，確保未超過每日消費限額。",
    onlinePaymentHints3:
      "如果付款沒有完成，請參閱如何處理付款被拒絕的情況，以了解詳細信息及其他付款方法。",
    onlinePaymentHints4: "有關取消費用和退款信息，請閱讀退款時限。",
    howToDealWithRejectionOfPayment: "如何處理付款被拒絕的情況",
    howToDealWithRejectionOfPayment1:
      "如果您的付款被拒絕，可能是由於以下某種原因：",
    howToDealWithRejectionOfPayment2:
      "您的卡超出了限額。請確認卡中有足夠的額度（可以檢查賬戶余額或者聯系發卡機構），或者試試另一張卡。",
    howToDealWithRejectionOfPayment3:
      "輸入的付款信息有錯誤，例如：帳單地址不正確或是信用卡到期日期有誤。請核對您輸入的信息，確保準確無誤。",
    howToDealWithRejectionOfPayment4:
      "不支持您提供的付款方法。核實付款頁面上的信息，確定是否接受您使用的付款方法。",
    howToDealWithRejectionOfPayment5:
      "由於出現技術問題，相關發卡機構無法授權您的交易。請聯系您的發卡機構，或者再試一次。",
    howToDealWithRejectionOfPayment6:
      "發卡機構發現，有一筆付款不符合您的正常消費模式，阻止了該交易，以保護您的安全。請聯系您的發卡機構，尋求幫助。",
    assistanceHelpContactUs: "如果您在付款方面需要協助，請聯系我們。",
    refundTimeLimit: "退款時限",
    refundTimeLimitOperate: "如何運作",
    refundTimeLimitOperate1:
      "Trip 需要 24 小時時間處理您的退款。您的退款處理完畢後，相關金融機構可能最多需要 7 天的時間將款項轉至您的賬戶，並且最多需要 2 個計帳周期才能在您的對帳單上列出該款項。",
    refundTimeLimitOperate2:
      "Trip 退款收據電子郵件中包含有關退款金額、退款方式以及退款完成時間的詳細信息。",
    refundTimeLimitOperate3:
      "低成本航空公司機票退款由第三方（即相應的低成本航空公司）而非本公司處理。關於退款時限及相關問題，請咨詢相關的第三方。",
    refundTimeLimitOperate4:
      "如果您符合退款條件並且同時使用積分和信用卡支付預訂費用，您將收到退還的積分和信用卡退款。任何取消費用將優先從信用卡退款中扣除，然後如有需要，再從積分中扣除。",
    planeTicketDetail1:
      "對於某些機票訂單，如您在 24 小時內取消預訂，則可獲得全額退款。",
    planeTicketDetail2: "有些機票則不可退款。",
    order: "訂單",
    makeAReservation:
      "您可以訪問Trip 網站或致電Trip 預訂機票。",
    makeAReservationFollowing:
      "您可以在Trip 網站上預訂以下類型的機票：",
    makeAReservationFollowing1: "往返機票，將回到始發機場。",
    makeAReservationFollowing2: "單程機票，從一地飛往另一地，不含回程。",
    makeAReservationFollowing3:
      "多個目的地的機票允許您在旅行期間遊覽多個目的地。",
    friendshipHintsDetail: "包機票價適用於往返機票或單程機票。",
    militaryAndBereavementFares: "軍人票價和喪親票價",
    militaryAndBereavementFaresDetail:
      "Trip 不會為軍人或喪親行提供機票折扣，但我們提供的票價特殊優惠可能比航空公司提供的軍人或喪親票價更低。請直接聯系航空公司咨詢軍人或喪親折扣票價，但請務必對比Trip 票價。",
    ticketBookingFee: "機票預訂費用",
    ticketBookingFeeDetail:
      "針對包含 2 家不同航空公司的往返機票訂單，Trip 會對每位乘客收取 USD7 的費用。例如：您為 2 位旅客預訂了往返機票，去程搭乘達美航空航班，回程搭乘聯合航空，則預訂費總計為 USD14。",
    followingBookingIsNotCharged: "以下預訂不收費：",
    followingBookingIsNotCharged1: "作為度假套餐一部分預訂的機票。",
    followingBookingIsNotCharged2: "旅行的各個航段均選擇同一家航空公司的航班。",
    passengersBookedAfterBookingAirTickets: "訂完機票後添加旅客",
    operationProcess: "操作流程",
    passengerOperationProcess1: "您無法在既有機票訂單中添加旅客。",
    passengerOperationProcess2: "如需添加同行的旅客，您需要重新預訂航班。",
    passengerOperationProcess3:
      "對於新預訂，Trip 不保證其價格與初始預訂相同。",
    childrenAlone: "兒童獨自乘機",
    childrenAloneDetail:
      "許多航空公司歡迎兒童在無成人陪伴的情況下乘坐其航班。但是，Trip 不會為年齡不滿 18 歲、獨自旅行的兒童預訂機票。",
    childrenAloneHints1: "許多航空公司可能會對獨自旅行的未成年人收取服務費。",
    childrenAloneHints2:
      "年齡不滿 5 歲的兒童以及年滿 17 歲的未成年人可能無法享受兒童獨自旅行服務。",
    childrenAloneHints3:
      "您需要提前向航空公司提供在最終目的地迎接兒童的成人的詳細聯系信息。",
    childrenAloneHints4:
      "在機場送兒童登機的成人和在最終目的地迎接兒童的成人都必須出示身份證。",
    childrenAloneHints5:
      "如果您的往返機票由兩個單程航班組成，請仔細查閱每家航空公司的相關規定。",
    contactAirlineAdviceOpportunityMinorsTravelAlone:
      "請聯系航空公司咨詢有關未成年人獨自乘機的政策。",
    airTicketsForMultipleDestinations: "預訂多個目的地的機票",
    operationSteps: "操作步驟",
    multipleTicketsOperationSteps1: "轉到Trip 機票頁面。",
    multipleTicketsOperationSteps2: "在搜索表單中選擇多個目的地。",
    multipleTicketsOperationSteps3: "輸入您的旅行目的地和日期，然後選擇搜索。",
    bookingHints1: "預訂前，請先登錄賬戶。",
    bookingHints2: "您的整個行程將保存為一個行程單。",
    takePetOpportunity: "攜帶寵物乘機",
    travelRequirements: "旅行要求",
    takePetOpportunityDetail:
      "如果您要攜帶寵物旅行，請聯系航空公司進行預訂。航空公司可能要求您的寵物滿足以下要求：",
    takePetOpportunityDetail1: "佩戴標有寵物名稱和寵物許可證號的項圈",
    takePetOpportunityDetail2:
      "由獸醫出具的健康狀況良好的最新證明（不超過 30 天）",
    takePetOpportunityDetail3: "狂犬病接種證明（如果跨國旅行）",
    takePetOpportunityDetail4: "大小和數量限制",
    takePetOpportunityDetail5:
      "航空公司會限制允許攜帶進入艙房的寵物的數量和大小。通常，您可以攜帶小型寵物；只要用於裝運它們的籠子可放在您前面座位的下方即可。",
    takePetOpportunityDetail6:
      "航空公司會限制在貨艙中托運的動物的數量，具體視飛機和天氣情況而定。",
    takePetOpportunityDetail7:
      "如果您的往返機票由兩個單程航班組成，請仔細查閱每家航空公司的相關規定。",
    takePetOpportunityDetail8: "額外費用",
    takePetOpportunityDetail9:
      "如果需要攜寵物進艙房或者在貨艙托運寵物，大多數航空公司都會收取相關費用。",
    takePetOpportunityDetail10: "請聯系航空公司，了解具體的寵物相關規定。",
    takeChildrenByChance: "帶兒童乘機",
    ticketRequirementsForChildren: "兒童的機票要求",
    takeChildNotNeedTickets: "在以下情況下，您無需為兒童訂票：",
    takeChildNotNeedTickets1: "您預訂國內航班。",
    takeChildNotNeedTickets2: "兒童在航班起飛時未滿 2 周歲。",
    takeChildNotNeedTickets3:
      "嬰兒乘坐在另一位滿足最低年齡要求的旅客的膝上。請致電航空公司了解詳情。",
    takeChildNotNeedTickets4: "該旅客腿上只能坐 1 名幼兒。",
    takeChildMustTickets: "在以下情況下，您必須為兒童訂票：",
    takeChildMustTickets1: "您預訂國際航班。",
    takeChildMustTickets2: "兒童在航班起飛時已滿 2 周歲。",
    takeChildMustTickets3: "兒童需要坐在自己的座位上。",
    ticketRequirementsForChildrenDetail:
      "航空公司的政策規定，一位符合航空公司所要求的最低年齡的乘客最多可攜 2 名嬰兒，但嬰兒需分別坐在各自的位子上。",
    discountForChildrenFares: "兒童票價折扣",
    discountForChildrenFaresDetail1:
      "部分航空公司提供兒童票價折扣。票價是否提供折扣取決於您所選的航班、座位的供應情況以及旅客的年齡。",
    discountForChildrenFaresDetail2:
      "要查看所有適用的折扣，請確保在您搜索航班時選擇同行兒童的人數和年齡。折扣票價已包含在您的搜索結果中，雖然可能不會標記為折扣票價。",
    documentationRequirementsChildren: "兒童的文件要求",
    documentationRequirementsChildren1:
      "對於國內航班，您可能需要為兒童提供帶照片的身份證。",
    documentationRequirementsChildren2:
      "對於國際航班，您必須為所有年齡段的兒童提供有效護照。",
    documentationRequirementsChildren3:
      "父母均無陪同的兒童可能需要提供公證文件和授權書方可入境其他國家/地區。請向您目的地的大使館或領事館確認您的具體文件要求。",
    vehicleUseChildSafetySeats: "兒童安全座椅",
    vehicleUseChildSafetySeatsDetail:
      "部分航空公司要求憑自己的機票乘機的兒童坐在安裝並卡在飛機座位上的兒童安全座椅中。",
    babyCarriage: "嬰兒車",
    babyCarriageDetail:
      "在通過機場安檢時，請折疊起嬰兒車並將其連同您的其他物品一起穿過安檢掃描設備。如果您選擇托運嬰兒車，許多航空公司將免費為您托運。",
    stillNeedHelp: "仍然需要幫助？",
    stillNeedHelpChild: "請聯系航空公司咨詢有關兒童乘機的政策。",
    stillNeedHelpDetail: "請聯系航空公司咨詢有關兒童乘機的政策。",
    other: "其他",
    accountSetting: "賬戶設置",
    changeEmailAndPassword: "變更電子郵件和密碼",
    changeEmailAndPasswordOpera: "如需變更郵箱和密碼，請執行以下操作：",
    changeEmailAndPasswordOpera1: "在個人信息頁面上，選擇電子郵件和密碼。",
    changeEmailAndPasswordOpera2: "按照指示輸入您的信息。",
    changeEmailAndPasswordOpera3: "分別選擇保存以更新您的電子郵件和密碼。",
    manageYourAccount: "管理您的Trip 賬戶",
    manageYourAccountDetail:
      "通過Trip 賬戶，您可以查看行程、改簽和退票",

    createAnAccountFollowing: "如需創建賬戶，請執行以下操作：",
    createAnAccountFollowingDetail:
      "前往創建您的免費賬戶，並選擇使用您的 Facebook 、谷歌賬戶、郵箱或手機號碼註冊賬戶。",
    manageAnAccountFollowing: "如需管理賬戶，請執行以下操作：",
    manageAnAccountFollowing1: "前往個人中心。",
    manageAnAccountFollowing2: "選擇常旅客管理以設置個人信息。",
    manageAnAccountFollowing3: "選擇支付管理以更新您的付款詳細信息。",
    manageAnAccountFollowing4: "選擇優惠券以查看和兌換您的優惠券。",
    addNewPassengersAccountFollowing: "如需賬戶添加新旅客，請執行以下操作：",
    addNewPassengersAccountFollowing1: "前往個人中心。",
    addNewPassengersAccountFollowing2: "選擇常旅客管理。",
    addNewPassengersAccountFollowing3: "選擇 +添加常旅客信息。",
    addNewPassengersAccountFollowing4: "按照指示添加旅客的個人信息。",
    addNewPassengersAccountFollowing5: "選擇保存。",
    closeYourAccountContactUs: "如果您希望關閉賬戶，請聯系我們。",
    sitesOnMobileDevices: "在移動設備上訪問Trip 網站",
    sitesOnMobileDevicesDetail:
      "如需在移動設備上訪問Trip 網站，可直接在瀏覽器中輸入 www.oneworldTrip.com。",
    mobileWebHints: "移動 Web 上提供的服務可能因設備而異。",
    associatedWithYourOtherAccounts:
      "關聯您的Trip 和 Facebook 、微信、谷歌賬戶",
    associatedWithYourOtherAccountsDetail:
      "將Trip 賬戶與 Facebook 賬戶進行關聯，可確保在登錄 Facebook、微信、谷歌後即會登錄Trip 這樣您就無需記住多個密碼。",
    stepsAssociatedWithAccounts: "關聯賬戶的步驟",
    stepsAssociatedWithAccounts1:
      "在登錄頁面上，選擇登錄 Facebook、微信或谷歌。",
    stepsAssociatedWithAccounts2:
      "系統出現提示時，輸入與您的 Facebook 賬戶關聯的電子郵件地址",
    stepsAssociatedWithAccounts3:
      "如果該電子郵件地址未與您的Trip 賬戶相關聯，請遵循相關說明關聯您的賬戶。",
    associatedAccountsHints1:
      "關聯賬戶不會為您訂閱Trip 的 Facebook、谷歌動態消息。",
    associatedAccountsHints2:
      "Trip 不會在未得到您許可的情況下，在您的 Facebook 、谷歌賬戶上發布信息。",
    associatedAccountsHints3:
      "Trip 仍會將您的行程信息發送到與Trip 賬戶關聯的電子郵件地址。",
    associatedAccountsHints4:
      "要查看關聯的賬戶，請轉到我的賬戶並選擇賬號綁定。",
    updatePassportInformation: "更新賬戶中的護照信息",
    updatePassportInformationDetail:
      "您可以為自己或其他旅客添加、變更或刪除存儲在Trip 賬戶中的護照信息。",
    updatePassportInformationOpera: "如需訪問護照信息，請執行以下操作：",
    updatePassportInformationOpera1: "登錄賬戶。",
    updatePassportInformationOpera2: "轉至個人中心。",
    addNewPassport: "如需添加新護照，請執行以下操作：",
    addNewPassport1: "選擇護照。",
    addNewPassport2: "輸入簽發護照的國家/地區。",
    addNewPassport3: "輸入護照號碼。",
    addNewPassport4: "選擇保存。",
    changeYourPassportNumber: "如需更改護照號碼，請執行以下操作：",
    changeYourPassportNumber1: "在護照下，選擇要變更的護照對應的編輯。",
    changeYourPassportNumber2: "變更現有的護照號碼。",
    changeYourPassportNumber3: "選擇保存。",
    deleteYourPassport: "如需刪除護照，請執行以下操作：",
    deleteYourPassport1: "在護照下，選擇要刪除的護照對應的編輯。",
    deleteYourPassport2: "選擇刪除。",
    deleteYourPassport3: "出現提示時，選擇是，確認刪除護照。",
    passportHints:
      "您可以轉到常旅客管理，選擇其他旅客並執行上述相同步驟，對已保存的旅客護照信息進行修改。",
    travelDocuments: "旅行證件",
    customsRequirements: "海關要求",
    customsRequirementsDetail:
      "到其他國家/地區旅行時，請準備好以下證件，以便向海關工作人員出示：",
    customsRequirementsDetail1:
      "公民身份證明，例如有效護照或政府發放的帶照片並且蓋有鋼印的身份證件和出生證明。",
    customsRequirementsDetail2: "旅行簽證（如果要遊覽的國家/地區有此要求）。",
    customsRequirementsDetail3: "空乘人員或遊輪員工提供的海關申報表。",
    internationalTravelDocument: "國際旅行證件",
    internationalTravelDocumentDetail:
      "如果您要跨國旅行，則需要準備好旅行證件，例如護照、旅行簽證、ETA 或 ESTA。如果您沒有準備好所需的證件，許多國家或地區都會拒絕您入境。為幫助您避免繳納緊急預訂費，並在旅行前提前準備好旅行證件。",
    passportDetail:
      "護照是政府簽發的形似銀行存折的身份證件（適用於所有國際旅行）或護照卡（僅適用於美國、加拿大、墨西哥、加勒比海和百慕大地區範圍內的海陸旅行）。",
    visa: "簽證",
    visaDetail:
      "旅行簽證授權旅客進入和離開特定國家或地區。您可能需要為行程中的各個港口或中轉站分別辦理簽證，因此請提前核實。",
    ESTAdetal: "ESTA（旅行許可電子系統）是非美國公民進入美國時必須辦理的證件。",
    ETAaustralia: "澳大利亞或加拿大旅行所需的 ETA",
    ETAaustraliaDetail:
      "ETA（電子旅行簽證）是非澳大利亞公民前往澳大利亞或非加拿大公民免簽前往加拿大必須辦理的證件。獲得批準後，該證件將與您的護照相關聯；因此無需攜帶額外的證件。您可以在澳大利亞電子旅行簽證或加拿大電子旅行簽證網站上找到相關申請及詳細信息。",
    minorsTravelToSouthAfrica: "未成年人前往南非旅行",
    minorsTravelToSouthAfricaDetail:
      "對於前往南非進行國際旅行的所有未成年人，南非要求除提供護照外，還需提供出生證明。有關詳細信息，請查看南非有關攜帶兒童出行的規定。",
    privacyAndSecurity: "隱私與安全",
    bewareOfEmailFraud: "謹防電子郵件詐騙",
    bewareOfEmailFraud1:
      "網絡釣魚是一種詐騙行為，通過以下方式實施：犯罪分子發送電子郵件索取個人信息，並企圖誘騙收件人做出點擊鏈接、打開附件等反應或直接提供敏感信息。",
    bewareOfEmailFraud2:
      "這些電子郵件貌似由知名的企業或組織發出，而且有時還附帶鏈接來指向貌似合法的網站，因此極易讓人信以為真。但是，您提供的信息（如身份證號或信用卡號）會直接轉到犯罪分子手中，然後他們會利用這些信息為自己牟利。",
    countermeasures: "應對措施",
    countermeasuresDetail:
      "Trip 絕不會打電話或發送電子郵件，詢問您的密碼或其他個人信息。如果您認為自己收到了欺詐性電子郵件：",
    countermeasuresDetail1: "切勿點擊郵件中的任何鏈接或打開任何附件",
    countermeasuresDetail2:
      "將整個電子郵件轉發至reynold.zhang@5u6o7se0.dingmail.work 或聯系我們。",
    countermeasuresDetail3: "刪除該電子郵件。",
    pleaseReadOurPrivacyPolicy:
      "請閱讀我們的隱私政策，詳細了解我們如何保護您的信息。",
    watchOutForTelephoneFraud: "警惕電話詐騙",
    watchOutForTelephoneFraudDetail:
      "您是否收到過自動打來的電話，聲稱您中了Trip 或其他知名旅遊公司提供的某項大獎？這就是電話詐騙。一定要掛斷電話，不要告訴來電者任何信息。",
    whatIsIt: "這是什麽？",
    whatIsIt1: "騙子們慣用一些“哄騙”的手段，使他們的來電號碼貌似來自本地。",
    whatIsIt2:
      "電話一開始通常是段預先錄制好的語音留言，自稱是Trip 或其他知名旅遊公司並告訴接聽者“贏得”了某種大獎或旅遊服務折扣。這些大獎可能包括現金卡、免費旅遊或旅遊積分，當然都是假的。",
    whatIsIt3:
      "由於來電者會想方設法隱藏自己的身份，或者假裝自己代表某家知名企業或機構，所以這種電話聽上去可能相當可信。但是，您提供的姓名、地址、付款信息、身份證號等信息會直接落到罪犯手中，他們可能會利用這些信息實施犯罪。",
    countermeasuresPhone1:
      "Trip 絕不會打電話或發送電子郵件，詢問您的密碼或其他個人信息。如果您認為自己接到了欺詐性電話：",
    countermeasuresPhone2:
      "掛斷電話。不要與來電者交談。記下顯示的號碼（如果有的話）以及來電者提供的其他有助於辨別身份的信息。",
    countermeasuresPhone3: "將詐騙電話的相關信息發送至reynold.zhang@5u6o7se0.dingmail.work",
    paymentSecurityOptions: "付款安全和選項",
    paymentSecurityOptions1:
      "Trip 賬戶可保護您的個人信息，並可為您保存付款信息，用於將來預訂旅行。",
    paymentSecurityOptions2:
      "Trip 采用最高的數字信息安全標準 - SSL，保護您的個人信息。只需核對瀏覽器中的地址是否以 https:// 開頭，就能確認這一點。",
    paymentSecurityOptionsOpera: "如需將信用卡保存至賬戶，請執行以下操作：",
    paymentSecurityOptionsOpera1: "登錄個人中心。",
    paymentSecurityOptionsOpera2: "選擇支付管理。",
    paymentSecurityOptionsOpera3: "填寫必填字段，然後選擇保存。",
    paymentSecurityOptionsOpera4:
      "為了防止您的卡未經授權被使用，我們每次消費交易都會驗證其 3 或 4 位安全碼。此安全碼位於大多數卡的簽名欄中；如果是美國運通卡，則位於信用卡卡號上方。",
    paymentSecurityOptionsHints1:
      "如果付款沒有完成，請參閱如何處理付款被拒絕的情況，以了解詳細信息及其他付款方法。",
    paymentSecurityOptionsHints2:
      "除非另有說明，否則Trip 網站上的所有價格均以欧元 (EUR, €) 報價。",
    protectingYourPersonalInformation:
      "Trip 十分註重保護您的個人信息。有關詳細信息，請查閱我們的隱私政策。",
    disclosingWebsiteVulnerabilities: "負責披露Trip 網站漏洞",
    disclosingWebsiteVulnerabilities1:
      "Trip 及其附屬公司鼓勵客戶報告在我們的任何互聯網站點上發現的漏洞。如果您認為您在我們的任何站點上的 Web 應用程序代碼中發現了漏洞，請向我們發送一封電子郵件，並提供以下信息：",
    disclosingWebsiteVulnerabilities2: "發現漏洞的日期和時間",
    disclosingWebsiteVulnerabilities3: "具體代碼",
    disclosingWebsiteVulnerabilities4: "概念驗證漏洞攻擊信息",
    thankYouEnsureSafety:
      "我們非常感謝您願意與我們共同努力確保 Trip  的安全。",

    issuedWithin5mins: "此航程由廉航提供，預計支付後5分鐘內完成出票！",
    priceChangeFrequently: "班機價格變動頻繁，請及時付款",
    paymentTimeLeft: "剩餘付款時間",
    contactNumber: "聯繫電話",
    perPerson: "人",
    price: "票價",
    transferTo: "中轉",
    checkCodeFailed: "校驗編碼失敗，訂單失效，請重新下單",

    selectState: "請選擇縣/省/市/自治區",
    enterBillingAddress: "請輸入有效的帳單地址 ",
    enterCity: "請輸入有效的都市",
    enterValidEmailAddress: "請輸入有效的電子郵寄地址",
    //enterFirstName:"請輸入姓名",
    //enterLastName:"請輸入姓氏",
    settingDefault: "設為默認",
    confirmDelete: "確認删除?",
    //selectCountryTerritoryCode:"請選擇國家/地區編碼",
    //selectCountryTerritory:"請選擇國家/地區",
    modifying: "修改中",
    modifySuccessful: "修改成功",
    addIn: "添加中",
    addSuccessful: "添加成功",
    airlineA: "航空公司",
    //selectGender:"請選擇性別",
    //selectDateOfBirth:"請選擇生日",
    //selectNationality:"請選擇國籍",
    //selectIDtype:"請選擇證件類型",
    //enterIDnumbers:"請輸入證件號碼",
    //selectExpiryDateOfCredentials:"請選擇證件有效日期",
    //selectCountryForIssuingDocuments:"請選擇證件發行國家",
    selectTypeOfPassenger: "請選擇旅客類型",
    selectCarrier: "請選擇航空公司",
    enterAirlineCard: "請輸入航司卡號",
    payFaild: "您的{tripTypeText}機票下單成功,但是在支付的時候失敗了！",
    paying: "您的{tripTypeText}機票付款中",
    paySuccess: "您的{tripTypeText}機票付款成功!",
    aircraftType: "機型",

    RefundChangeRules: "退票/改簽規則",
    nonRefundableNonChangeable: "不可改退",
    nonFree: "有條件改/退",
    forFree: "免費改/退",
    toBeDetermined: "暫不明確",
    typeOfChanging: "改簽類型",
    typeOfRefund: "退票類型",
    adultTicket: "成人票",
    childrenTicket: "兒童票",
    infantTicket: "嬰兒票",
    flightInformation: "航程資訊",
    enterReasonsDetails: "請輸入具體原因，限300字（非必須）",
    onwardItinerary: "去程資訊",
    returnItinerary: "返程資訊",
    hasClosed: "已關閉",
    second: "秒",
    payLCCFaild: "您的機票下單失敗!",
    paymentFailed: "支付失敗",
    payTimeOnly: "付款時間僅剩",
    changeTheRouteInformation: "改簽航段資訊",
    chooseTheReasonForRefund: "選擇退票原因",
    chooseReasonsForChanging: "選擇改簽原因",
    chooseFlightNeedRefund: "選擇退票班機",
    chooseFlightNeedRefundPle: "請選擇退票班機",
    confirmRefundOrder: "確認退票訂單",
    confirmRefund: "確認退票",
    refundUnderReview:
      "您的行程：{startAddress}-{endAddress}退票申請我們已經收到，正在稽核中",
    changing: "正在改簽",
    refundMethod: "退款方式",
    basedOnTheActualPaymentTimeOfTheBank:
      "如審核通過,我們預計將會在7個工作日內根據您的支付賬戶原路返回,請以銀行實際到款時間為準",
    enterYourAccount: "請輸入您的收款銀行卡號",
    involuntaryRefund: "因航空公司原因退票，請選擇",
    flightDelayOrCancellationOrTimeChange: "航班延誤或取消、航班時刻變更",
    involuntaryChange: "因航空公司原因改簽，請選擇",
    chooseToChangeTheOnwardFlight: "選擇去程改簽班機",
    chooseToChangeTheFlightPle: "請選擇改簽班機",
    chooseToChangeFlightInformation: "選擇改簽班機資訊",
    chooseToChangeTheFlight: "選擇改簽班機",
    ticketing: "出票中",
    confirmTheChangeOfTheSegment: "確認改簽航段",
    grounding: "停飛",
    ticketA: "票",
    changeHasBeenSuccessfullySubmitted: "您的{tripTypeText}機票改簽已成功提交",
    changingPleasePatient: "目前正在改簽中，請您耐心等待",
    selectLeastOneTicketOperate: "請至少選擇一張票進行操作",

    startAndEndDateOrderSearchCriteria:
      "請您輸入訂單創建的起止日期做為搜索條件",
    orderDetailsNotFound: "暫未找到訂單詳細資訊，請稍後",
    noRefundDetailsFound: "暫未找到退票詳細資訊，請稍後",
    queryRefundInformationBusy: "査詢退票資訊正忙，請稍後",
    logInWithPhoneJustRegistered: "請用您剛注册的手機號登入",
    isAltering:
      "您的票已經有待改簽航程信息，如您需要重新選擇請先刪除選擇的航程！",
    licenseNumber: "牌照號碼：352898",
    aboutUs: "關於我們",
    companyProfile: "公司簡介",
    loginNow: "預定前先登入，可賺取積分",
    memberLogin: "會員登入",
    selectFlight: "選擇飛往",
    goFlight: "的去程航班",
    returnFlight: "的返程航班",
    enterOldPassword: "請輸入原密碼",
    oldPasswordNew: "輸入原密碼",
    enterNewPasswordNew: "請輸入新密碼",
    newPasswordAgain: "請再次輸入新密碼",
    leftNum1: "剩余",
    leftNum2: "個座位",
    reimburse: "報銷憑證",
    selectReimburse: "選擇報銷憑證服務",
    reimburseEmail: "報銷憑證會在7個工作日內發送至您的主要聯系人郵箱",
    cabinIsNotavilable1: "很抱歉，您選擇的艙位不足",
    cabinIsNotavilable2: "人，請重新查詢預訂！",
    personalOrCompany: "個人/企業",
    passwordWrong: "賬號不存在或密碼錯誤",
    phoneNumberRegisteredNo: "該手機號未註冊",
    EnterPassWordAgainPlace: "再次輸入密碼",
    searchAgian: "重新搜索",
    noOrdertoAlter: "對不起，您暫時沒有可改簽的機票",
    reimburseTitle: "擡頭",
    enterReimburseTitle: "請輸入擡頭",
    passportNum: "護照號碼",
    createPassword: "建立密碼",
    passwordFormatError: "密碼格式錯誤",
    initFromCity: "香港/HKG-HK",
    insurance: "保險",
    insuranceOrder: "保險訂單",
    insuranceOrderStatus: "保單狀態",
    searchInsuranceOrder: "尋找保單",
    insuranceOrderNum: "保單號",
    insurancePriceTotal: "保單總額",
    insuranceSourcePrice: "原價",
    insurancePriceOff: "折",
    insurancePerson: "受保人",
    zurichOne_1: "·「蘇黎世自遊易保險計劃」為您的海外旅行提供全方位保護，每位",
    zurichOne_6: "",
    zurichOne_2: "，為期",
    zurichOne_3: "天",
    zurichOne_4: "。有关此保障详情，",
    zurichOne_5: "請點擊此處",
    zurichTwo: "· 蘇黎世保險有限公司為此旅遊保險單之承保人",
    zurichThree: "· 香港五洲國際旅遊有限公司為蘇黎世保險有限公司委託之保險代理",
    zurichFour_1:
      "為此行程所有旅客安排「蘇黎世自遊易保險計劃」 (我已閱讀、明白及同意遵守此之",
    zurichFour_2: "聲明",
    zurichFour_3: "個人資料（私隱）條例",
    zurichFour_4: "及",
    zurichFour_5: "保單條款及細則",
    zurichFour_6:
      "。所有旅客均由香港出發並於旅程完結時返回香港，而此次旅程只屬悠閒旅遊或不涉及任何體力勞動的商務旅遊。)",
    valueAddedServices: "保險",
    travelInsurance: "保險詳情",
    insuranceAndEase: "一份保險 多份安心",
    nobuyThanks: "不購買，謝謝",
    zurichCheck:
      "好，我要為此行程所有旅客安排「蘇黎世自遊易保險計劃」 (我已閱讀、明白及同意遵守此之",
    zurichServer_1: "· 旅程取消、旅程延誤",
    zurichServer_2: "· 24小時全球緊急支援服務",
    zurichServer_3: "· 保障壹般旅遊活動",
    insurancePrice: "保費",
    passengerInformation: "乘客信息",
    enterName: "請輸入名字",
    emergencyContact: "緊急聯繫人",
    contactInformation: "聯繫人信息",
    clearFilter: "清除全部",
    loadingMore: "更多航班信息加載中",
    title: "Trip-廉價航空|特價機票查詢|機票預訂",
    getPrice: "獲取價格",
    recommendationsforyou: "為您推薦",
    frequentFlyerNumberOptional: "常旅客號碼（選填）",
    frequentFlyerProgram: "常旅客計劃",
    frequentFlyerNumber: "常旅客號碼",
    frequentFlyerNumberPlease: "請填寫常旅客號碼",
    frequentFlyerMsg:
      "如果您的登記人信息已與里程卡相連，航空公司會自動為您累積飛行里程。",
    pullDownLoadMore: "下拉加載更多航班信息",
    carryonBaggage: "手提行李",
    oldPasswordError: "舊密碼錯誤",
    passwordModificationFailed: "密碼修改失敗",
    localTime: "當地時間",
    hongKongDollar: "港幣",
    newTaiwanDollar: "新台幣",
    usdDollar: "美元",
    eurDollar: "歐元",
    cnyDollar: '人民幣',
    chooseArenewalApplicant: "選擇改簽申請人",
    moreSegments: "更多航段",
    refundRequestSuccess: "您的退票申請已成功提交",
    refundingPleasePatient: "目前正在審核中，請您耐心等待",
    noMatchingData: "無匹配數據",
    popularCities: "熱門城市",
    refunding: "正在退票",
    clickToView: "點擊查看",
    NotAllowedSameNum: "不允許輸入相同的證件號",
    VJVZreadAndAgree: "已閱讀並同意 ",
    VJAgree: "越捷航空條款和條件",
    VZAgree: "泰國越捷航空條款和條件",
    passportRepeated: "護照號碼重複",
    additionalServices: "附加服務",
    seatSelection: "選座",
    seatServices: "選座服務",
    allFlights: "全部航程",
    pleaseSelectSeat: "請選擇座位",
    seatRemark: "備註，限100字（非必須）",
    seatNote1:
      "1、在航班起飛前，您可以足不出戶，根據自己的喜好事先在網上選擇座位，並於航空公司櫃臺辦理乘機",
    seatNote2:
      "2、通過網絡提前預訂航班座位，讓您從容、便捷、壹步到位地享受從訂票到選座的便捷高效服務",
    seatNote3:
      "3、由於航司和航線的規則不同，無法確保100%選座成功，若您所購買的選座服務未處理成功，系統將會自動全額退款",
    ageDateCalc: "注意：年齡計算都以實際班機最後起飛日期為準。",
    ageCalculation: "注意：年齡計算都以實際班機最後起飛日期為準。",
    aboutDescTitle: "讓我們帶您樂遊五洲！",
    aboutDescText:
      "為滿足市場需求，我們不斷創新旅遊產品，挖掘低價，培訓員工提升服務。 經過不懈的努力，近幾年與全球三大旅遊科技公司達成戰略合作夥伴，提供全球超過500家航空公司數據； 同時，不斷拓展境外當地合作夥伴，獲取最優資源，業務網絡覆蓋全球40多個國家和地區，去年全年銷售總額達到35億，仍在不斷增長。",

    baggageAllowance: "行李額",
    selectBaggage: "添加行李",
    baggageSelection: "選擇行李額",
    baggagePiece: "件",
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/lang/homePage/zhCHT.js
// module id = XQQo
// module chunks = 34